const messages = {
        ru: {
          translations: {
            quickCharge: {
              button: "Быстрый счёт",
              title: "Быстрый счёт",
              customer: "Клиент",
              amount: "Сумма",
              reason: "Назначение",
              defaultReason: "Оплата услуги",
              create: "Создать счёт",
              cancel: "Отмена",
              created: "Счёт создан",
              linkHint: "Отправьте ссылку клиенту в чат или скопируйте",
              noLink: "Счёт создан, но аккаунт Tranzila для ссылки не настроен.",
              noLinkButCreated: "Создано — настройте Tranzila для ссылки",
              done: "Закрыть",
              copy: "Копировать ссылку",
              copied: "Ссылка скопирована",
              sendToChat: "Отправить в чат",
              sent: "Ссылка отправлена клиенту",
              chatPrefix: "Безопасная оплата на",
              invalidAmount: "Введите корректную сумму"
            },
            errorBoundary: {
              pageTitle: "Не удалось загрузить экран",
              pageBody: "Попробуйте обновить. Остальная система работает.",
              reload: "Обновить",
              sectionFailed: "Не удалось загрузить этот раздел."
            },
            voiceIntelligence: {
              title: "Voice Intelligence — Центр управления",
              tabs: {
                overview: "Обзор",
                calls: "Звонки",
                search: "Поиск",
                agents: "Агенты",
                collection: "Взыскание",
                insights: "Аналитика"
              },
              range: {
                label: "Период",
                days7: "7 дней",
                days30: "30 дней",
                days90: "90 дней"
              },
              widgets: {
                totalCalls: "Всего звонков",
                totalDuration: "Общая длительность",
                avgDuration: "Средняя длительность",
                callsToday: "Звонков сегодня",
                callsThisWeek: "Звонков за неделю",
                callsThisMonth: "Звонков за месяц",
                callsAnalyzed: "Звонков проанализировано",
                callsPendingAnalysis: "Ожидают анализа",
                collectionCalls: "Звонки по взысканию",
                vipCalls: "VIP-звонки",
                followUpRequired: "Требуют контроля"
              },
              agents: {
                title: "Звонки по агентам",
                agent: "Агент",
                calls: "Звонки",
                duration: "Общее время",
                avgDuration: "Среднее",
                unassigned: "Не назначен",
                empty: "Нет звонков за выбранный период"
              },
              notEnabled: {
                title: "Голосовой модуль не включён",
                body: "Включите Voice в настройках или обратитесь к администратору."
              },
              calls: {
                filters: {
                  search: "Поиск",
                  agent: "Агент",
                  outcome: "Результат",
                  has: "Содержит",
                  all: "Все",
                  hasRecording: "С записью",
                  hasTranscript: "С транскриптом",
                  hasAnalysis: "С ИИ-анализом",
                  qa: "Контроль качества",
                  noOutcome: "Без результата",
                  noTranscript: "Без транскрипта",
                  noAnalysis: "Без ИИ-анализа",
                  minMinutes: "Мин. минут",
                  maxMinutes: "Макс. минут"
                },
                columns: {
                  date: "Дата",
                  customer: "Клиент",
                  agent: "Агент",
                  outcome: "Результат",
                  duration: "Длительность",
                  tags: "Теги",
                  actions: "Действия"
                },
                actions: {
                  listen: "Прослушать",
                  download: "Скачать запись",
                  transcript: "Транскрипт",
                  openTicket: "Открыть диалог"
                },
                exportCsv: "Экспорт CSV",
                exportXlsx: "Экспорт Excel",
                exportSelectedCsv: "Экспорт выбранных CSV",
                exportSelectedXlsx: "Экспорт выбранных Excel",
                selected: "Выбрано: {{count}}",
                empty: "Нет звонков по выбранным фильтрам",
                transcriptTitle: "Транскрипт звонка",
                noTranscript: "Транскрипт недоступен"
              },
              outcomes: {
                sale: "Продажа",
                follow_up: "Контроль",
                support: "Поддержка",
                collection: "Взыскание",
                complaint: "Жалоба",
                no_answer: "Нет ответа",
                wrong_number: "Неверный номер"
              },
              agentsPerf: {
                topSales: "Лучший по продажам",
                topSupport: "Лучший по поддержке",
                topCollection: "Лучший по взысканию",
                mostActive: "Самый активный",
                highestConversion: "Лучшая конверсия",
                tableTitle: "Эффективность агентов",
                agent: "Агент",
                calls: "Звонки",
                answered: "Отвечено",
                avgDuration: "Средняя длительность",
                conversion: "Конверсия",
                unassigned: "Не назначен",
                empty: "Нет данных за период"
              },
              insights: {
                kpis: {
                  conversionRate: "Конверсия",
                  followUpRate: "Доля контролей",
                  noAnswerRate: "Доля без ответа",
                  complaintRate: "Доля жалоб",
                  collectionSuccessRate: "Успех взыскания",
                  collectionPromiseRate: "Обещания оплаты"
                },
                heatmapTitle: "Тепловая карта — звонки по часам и дням",
                noData: "Пока нет данных",
                topObjections: "Частые возражения",
                topActionItems: "Частые задачи",
                topIntents: "Основные темы",
                sentiment: "Тональность",
                days: {
                  sun: "Вс",
                  mon: "Пн",
                  tue: "Вт",
                  wed: "Ср",
                  thu: "Чт",
                  fri: "Пт",
                  sat: "Сб"
                },
                ask: {
                  title: "Спросите ИИ о звонках",
                  placeholder: "напр.: На что жалуются клиенты в этом месяце?",
                  button: "Спросить",
                  noData: "Недостаточно данных для ответа"
                }
              },
              collectionTab: {
                filters: {
                  all: "Все",
                  pending: "Ожидает",
                  promised: "Обещание оплаты",
                  paid: "Оплачено",
                  overdue: "Просрочено"
                },
                columns: {
                  date: "Дата",
                  customer: "Клиент",
                  agent: "Агент",
                  amountDue: "Долг",
                  amountPromised: "Обещано",
                  dueDate: "Срок",
                  status: "Статус",
                  actions: "Действия"
                },
                status: {
                  pending: "Ожидает",
                  promised: "Обещано",
                  paid: "Оплачено",
                  failed: "Ошибка"
                },
                openTicket: "Открыть диалог",
                empty: "Нет звонков по взысканию для фильтра"
              },
              branding: {
                title: "Voice Branding",
                note: "Фирменное приветствие и музыка ожидания. Воспроизведение в звонке включится после live-валидации Фазы 1.",
                enable: "Включить голосовой брендинг",
                welcomeTitle: "Приветствие",
                welcomeText: "Текст приветствия (TTS)",
                welcomeTextHint: "Если выбран и файл — приоритет у файла",
                welcomeAsset: "Файл приветствия (MP3)",
                waitingAsset: "Музыка ожидания (MP3)",
                language: "Язык",
                none: "Нет",
                assetsTitle: "Аудиофайлы",
                uploadKind: "Тип",
                upload: "Загрузить файл",
                noAssets: "Файлов нет — загрузите первый MP3",
                preview: "Прослушать",
                delete: "Удалить",
                saved: "Сохранено",
                uploaded: "Файл загружен",
                previewFailed: "Ошибка воспроизведения",
                kinds: {
                  welcome: "Приветствие",
                  waiting: "Ожидание",
                  announcement: "Объявление"
                }
              },
              search: {
                placeholder: "Поиск по транскриптам, ИИ-резюме, памяти клиента и заметкам…",
                button: "Искать",
                results: "{{count}} результатов",
                empty: "Ничего не найдено — попробуйте иначе",
                loadMore: "Показать ещё",
                openTicket: "Открыть диалог",
                scopes: {
                  all: "Все",
                  transcripts: "Транскрипты",
                  analyses: "ИИ-резюме",
                  memory: "Память клиента",
                  notes: "Заметки"
                },
                sources: {
                  transcript: "Транскрипт",
                  analysis: "ИИ-анализ",
                  memory: "Память",
                  notes: "Заметки"
                }
              }
            },
            common: {
              yes: "Да",
              no: "Нет",
              clean: "Очистить",
              connection: "Соединение"
            },
            enterprisePlan: {
              title: "Enterprise",
              pricing: "Индивидуальные условия",
              description: "Тариф под крупные команды",
              ctaContactSales: "Связаться с продажами"
            },
            buttons: {
              cancel: "Отмена",
              close: "Закрыть",
              save: "Сохранить",
              confirm: "Подтвердить",
              ok: "ОК",
              import: "Импорт",
              all: "Все"
            },
            signup: {
              title: "Регистрация",
              toasts: {
                success: "Пользователь успешно создан! Выполните вход.",
                fail: "Ошибка при создании пользователя. Проверьте введённые данные."
              },
              form: {
                name: "Имя",
                email: "Электронная почта",
                password: "Пароль"
              },
              buttons: {
                submit: "Зарегистрироваться",
                login: "Уже есть аккаунт? Войти!"
              }
            },
            admin: {
              tag: "Админ",
              exit: "Назад в рабочее пространство",
              enterSoftware: "Войти в систему",
              nav: {
                heading: "Платформа",
                overview: "Обзор",
                companies: "Компании",
                plans: "Тарифы",
                subscriptions: "Подписки",
                audit: "Журнал действий",
                compare: "Сравнение",
                broadcasts: "Рассылки",
                pages: "Страницы"
              },
              broadcast: {
                title: "Рассылки",
                subtitle: "Баннеры объявлений для всех тенантов или одного",
                refresh: "Обновить",
                compose: "Новая рассылка",
                publish: "Опубликовать",
                publishing: "Публикую…",
                cancel: "Отмена",
                empty: "Рассылок ещё нет. Создайте первую выше.",
                loadError: "Не удалось загрузить.",
                actionFailed: "Действие не выполнено",
                createFailed: "Не удалось опубликовать.",
                titleBodyRequired: "Заголовок и текст обязательны.",
                tenantTargetRequired: "Выберите целевого тенанта.",
                created: "Рассылка опубликована.",
                confirmDelete: "Удалить \"{{title}}\"? Нельзя отменить.",
                endsOn: "до {{date}}",
                col: {
                  title: "Сообщение",
                  severity: "Важность",
                  audience: "Аудитория",
                  created: "Создано",
                  actions: "Действия"
                },
                audience: {
                  all: "Все тенанты",
                  tenant: "Конкретный тенант"
                },
                form: {
                  title: "Заголовок",
                  body: "Текст",
                  severity: "Важность",
                  audience: "Аудитория",
                  target: "Целевая компания",
                  endsAt: "Истекает (необязательно)"
                },
                tooltip: {
                  active: "Активна (нажмите чтобы остановить)",
                  stopped: "Остановлена (нажмите чтобы запустить)"
                },
                aria: {
                  active: "Рассылка активна",
                  stopped: "Рассылка остановлена"
                }
              },
              compare: {
                title: "Сравнение тенантов",
                subtitle: "{{count}} из {{max}} выбрано · операционные KPI рядом",
                add: "Добавить тенанта",
                remove: "Убрать",
                searchPlaceholder: "Поиск по названию компании…",
                pickerEmpty: "Нет совпадений.",
                noPlan: "Без тарифа",
                slotEmpty: "—",
                empty: {
                  title: "Выберите тенантов для сравнения",
                  sub: "До 4 компаний — их операционные KPI будут показаны рядом."
                },
                row: {
                  metric: "Метрика",
                  status: "Здоровье",
                  msgs24h: "Сообщения 24ч",
                  tickets: "Открытые тикеты",
                  closed24h: "{{count}} закрыто",
                  whatsapp: "WhatsApp",
                  users: "Пользователи",
                  queuesN: "{{count}} очередей",
                  ai: "AI",
                  spark: "Объём 7 дн"
                }
              },
              audit: {
                title: "Журнал действий",
                subtitle: "Все действия операторов платформы по всем тенантам",
                refresh: "Обновить",
                reset: "Сбросить",
                empty: "Нет записей по вашему фильтру.",
                filter: {
                  action: "Действие",
                  allActions: "Все действия",
                  admin: "Админ",
                  allAdmins: "Все админы",
                  since: "С",
                  until: "По"
                },
                col: {
                  when: "Когда",
                  admin: "Админ",
                  action: "Действие",
                  target: "Цель",
                  ip: "IP"
                },
                pagination: {
                  showing: "{{start}}–{{end}} из {{total}}",
                  prev: "Назад",
                  next: "Далее"
                }
              },
              overview: {
                title: "Обзор компаний",
                subtitle: "Платформенные метрики по всем тенантам",
                loadError: "Не удалось загрузить обзор. Попробуйте обновить.",
                empty: "Пока нет данных.",
                kpi: {
                  companies: "Компании",
                  active: "Активные",
                  expiringSoon: "Истекают скоро",
                  within7Days: "В течение 7 дней",
                  mrr: "MRR (оц.)",
                  mrrSub: "Эквивалент в месяц",
                  newThisMonth: "+{{count}} в этом месяце"
                },
                signups: {
                  title: "Регистрации (6 мес.)",
                  sub: "Новых компаний в месяц"
                },
                plans: {
                  title: "Распределение по тарифам",
                  sub: "Доля компаний по уровню"
                },
                expiring: {
                  title: "Истекают скоро",
                  viewAll: "Показать все",
                  empty: "Нет истечений в ближайшие 7 дней.",
                  today: "сегодня",
                  tomorrow: "завтра",
                  inDays: "через {{days}} дн."
                },
                attention: {
                  title: "Нужна реакция",
                  sub: "Только счётчики — откройте Компании для действий",
                  suspended: "Приостановлены",
                  pastDue: "Просроченные",
                  aiOff: "AI выключен",
                  openCompanies: "Открыть Компании"
                },
                activity: {
                  title: "Недавняя активность платформы",
                  viewAll: "Открыть журнал действий",
                  empty: "Действий платформы пока нет.",
                  now: "только что",
                  minAgo: "{{count}} мин назад",
                  hAgo: "{{count}} ч назад",
                  dAgo: "{{count}} дн назад"
                }
              },
              health: {
                backToCompanies: "Назад к компаниям",
                loadError: "Не удалось загрузить данные тенанта.",
                actionFailed: "Действие не выполнено",
                justNow: "сейчас",
                status: {
                  healthy: "В норме",
                  watch: "Контроль",
                  critical: "Критично"
                },
                reason: {
                  suspended: "приостановлен",
                  no_whatsapp_session: "нет сессии WhatsApp",
                  whatsapp_disconnected: "WhatsApp отключён",
                  no_activity_24h: "нет активности 24ч",
                  past_due: "просрочено",
                  expiring_soon: "скоро истекает"
                },
                kpi: {
                  msgs24h: "Сообщения (24ч)",
                  totalLast24h: "Входящие + исходящие",
                  ticketsOpen: "Открытые тикеты",
                  closed24h: "{{count}} закрыто за 24ч",
                  whatsapps: "WhatsApp",
                  connectedTotal: "Подключено / всего",
                  users: "Пользователи",
                  queues: "{{count}} очередей"
                },
                volume: {
                  title: "Объём сообщений (7 дней)",
                  sub: "Только числа по дням"
                },
                config: {
                  title: "Конфигурация",
                  sub: "Только метаданные",
                  ai: "AI-помощник",
                  aiPromptSize: "Размер промпта AI",
                  chars: "симв.",
                  queues: "Очереди",
                  settings: "Строк настроек",
                  dueDate: "Дата окончания",
                  on: "Вкл",
                  off: "Выкл"
                },
                activity: {
                  title: "Последние действия админа",
                  sub: "Только операторы платформы",
                  empty: "Для этого тенанта нет записей.",
                  byUser: "админ #{{id}}"
                },
                action: {
                  impersonate: "Войти как тенант",
                  ai_enable: "AI включён",
                  ai_disable: "AI выключен",
                  suspend_tenant: "Приостановлен",
                  reactivate_tenant: "Реактивирован"
                },
                actions: {
                  enableAi: "Включить AI",
                  disableAi: "Выключить AI",
                  suspend: "Приостановить",
                  reactivate: "Реактивировать"
                },
                aiToggle: {
                  enabled: "AI включён",
                  disabled: "AI выключен"
                },
                confirm: {
                  suspend: "Приостановить {{name}}? Они не смогут войти.",
                  reactivate: "Реактивировать {{name}}?"
                },
                suspended: "Приостановлен",
                reactivated: "Реактивирован",
                toggleAiTip: "Включить/выключить AI для этого тенанта"
              }
            },
            login: {
              title: "С возвращением",
              subtitle: "Войдите, чтобы продолжить работу",
              form: {
                email: "Электронная почта",
                password: "Пароль",
                remember: "Запомнить меня",
                forgot: "Забыли пароль?"
              },
              buttons: {
                submit: "Войти",
                register: "Нет аккаунта? Зарегистрируйтесь!",
                haveAccount: "Впервые здесь?"
              },
              brand: {
                meta: "WhatsApp CRM",
                h1: "Диалоги,",
                h2a: "которые ",
                h2b: "закрывают",
                h3: "сделки.",
                subhead: "WhatsApp CRM на базе ИИ помогает управлять, автоматизировать и закрывать больше сделок — всё в одном месте.",
                f1: {
                  t: "Все диалоги в одном месте",
                  b: "Ни одного пропущенного сообщения. Всё под рукой."
                },
                f2: {
                  t: "Автоматизация экономит время",
                  b: "Умная автоматизация для быстрых результатов."
                },
                f3: {
                  t: "Инсайты для роста",
                  b: "Знай больше, решай лучше, закрывай чаще."
                }
              },
              secure: {
                title: "Безопасно и зашифровано",
                body: "Ваши данные в безопасности"
              }
            },
            companies: {
              title: "Регистрация компании",
              form: {
                name: "Название компании",
                plan: "Тариф",
                token: "Токен",
                submit: "Зарегистрировать",
                success: "Компания успешно создана!"
              }
            },
            auth: {
              toasts: {
                success: "Вход выполнен успешно!"
              },
              token: "Токен"
            },
            connections: {
              title: "Подключения",
              connected: "Подключено",
              hub: {
                statusBadge: {
                  connected: "Подключено",
                  pending: "Подключение",
                  disconnected: "Не подключено",
                  loading: "Загрузка…"
                },
                instagramNative: {
                  title: "Instagram",
                  description: "Подключите аккаунт Instagram напрямую — без страницы Facebook.",
                  connect: "Подключить Instagram",
                  reconnect: "Переподключить",
                  disconnect: "Отключить",
                  connected: "Instagram подключён!",
                  connectedSub: "Подключено напрямую",
                  idleSub: "Подключение через Instagram Business Login",
                  expiredSub: "Сессия истекла — переподключите"
                }
              },
              toasts: {
                deleted: "Подключение WhatsApp успешно удалено!"
              },
              confirmationModal: {
                deleteTitle: "Удалить",
                deleteMessage: "Вы уверены? Это действие нельзя отменить.",
                disconnectTitle: "Отключить",
                disconnectMessage: "Вы уверены? Необходимо будет повторно считать QR-код."
              },
              buttons: {
                add: "Добавить WhatsApp",
                disconnect: "Отключить",
                tryAgain: "Попробовать снова",
                qrcode: "QR КОД",
                newQr: "Новый QR КОД",
                connecting: "Подключение"
              },
              toolTips: {
                disconnected: {
                  title: "Не удалось запустить сеанс WhatsApp",
                  content: "Убедитесь, что ваш мобильный телефон подключен к интернету и повторите попытку или запросите новый QR-код"
                },
                qrcode: {
                  title: "Ожидание считывания QR-кода",
                  content: "Нажмите кнопку 'QR КОД' и считайте QR-код вашим мобильным телефоном для запуска сеанса"
                },
                connected: {
                  title: "Подключение установлено!"
                },
                timeout: {
                  title: "Соединение с мобильным телефоном потеряно",
                  content: "Убедитесь, что ваш мобильный телефон подключен к интернету и WhatsApp открыт, или нажмите кнопку 'Отключить' для получения нового QR-кода"
                }
              },
              table: {
                name: "Имя",
                status: "Статус",
                lastUpdate: "Последнее обновление",
                default: "По умолчанию",
                actions: "Действия",
                session: "Сеанс"
              }
            },
            rankings: {
              title: "Рейтинг",
              eyebrow: "Команда",
              topSeller: "🔥 Лидер месяца:",
              topPerformer: "Лучший результат",
              salesLabel: "Продажи",
              table: "Таблица продаж",
              period: "Период",
              totalSales: "Всего продаж",
              rank: "#",
              name: "Имя",
              sales: "Продажи",
              actions: "Действия",
              stats: {
                agents: "Агенты"
              },
              empty: {
                title: "Продажи ещё не записаны",
                adminHelp: "Продажи — это ручной счётчик. Откройте Пользователи и отредактируйте каждого агента, чтобы установить его сумму продаж.",
                userHelp: "Когда администратор запишет продажи команды, рейтинг появится здесь.",
                editUsersBtn: "Открыть пользователей"
              }
            },
            appointments: {
              title: "Записи",
              eyebrow: "Планирование",
              heroSubtitleAdmin: "Управляйте тем, как WhatsApp-бот записывает клиентов и что попадает в ваш календарь.",
              heroSubtitleOperator: "Смотрите записи, созданные WhatsApp-ботом.",
              common: {
                cancel: "Отмена",
                back: "Назад"
              },
              when: {
                today: "Сегодня",
                tomorrow: "Завтра"
              },
              summary: {
                allWeek: "Вся неделя"
              },
              connect: {
                title: "Подключить календарь",
                subtitle: "AI-бот читает свободные окна из подключённого календаря и создаёт события, когда клиенты записываются через WhatsApp.",
                notConnectedTag: "Календарь не подключён",
                googleBtn: "Подключить Google Calendar",
                microsoftBtn: "Подключить Outlook",
                statusConnected: "Подключено",
                lastSynced: "Синхронизация",
                disconnectBtn: "Отключить",
                confirmDisconnectTitle: "Отключить календарь?",
                confirmDisconnectBody: "Бот перестанет предлагать слоты и создавать события, пока календарь не подключите снова. Существующие записи сохранятся.",
                disconnectedToast: "Календарь отключён"
              },
              workingHours: {
                eyebrow: "Настройки",
                title: "Рабочие часы",
                subtitle: "Дни и часы, когда бот может предлагать слоты.",
                daysLabel: "Дни, в которые бот может предлагать",
                days: {
                  0: "Вс",
                  1: "Пн",
                  2: "Вт",
                  3: "Ср",
                  4: "Чт",
                  5: "Пт",
                  6: "Сб"
                },
                startLabel: "Начало",
                endLabel: "Конец",
                saveBtn: "Сохранить",
                savingBtn: "Сохранение...",
                savedToast: "Настройки сохранены"
              },
              slotConfig: {
                durationLabel: "Длительность слота",
                bufferLabel: "Буфер между слотами"
              },
              bookings: {
                eyebrow: "Активность",
                title: "Записи",
                upcomingLabel: "предстоящих",
                totalLabel: "всего",
                emptyTitle: "Пока нет записей",
                emptyBody: "Они появятся здесь автоматически, как только клиент запишется через WhatsApp-бот.",
                cols: {
                  customer: "Клиент",
                  phone: "Телефон",
                  scheduledAt: "Когда",
                  status: "Статус",
                  type: "Тип",
                  location: "Место",
                  actions: ""
                },
                statuses: {
                  pending: "Ожидает",
                  confirmed: "Подтверждено",
                  reminderSent: "Напоминание",
                  completed: "Завершено",
                  cancelled: "Отменено"
                },
                cancelBtn: "Отменить запись",
                confirmCancelTitle: "Отменить запись?",
                confirmCancelBody: "Событие в календаре будет удалено и клиент получит уведомление.",
                confirmCancelBtn: "Отменить",
                cancelledToast: "Запись отменена"
              },
              errors: {
                connectFailed: "Не удалось открыть экран согласия провайдера."
              },
              botConfig: {
                eyebrow: "Бот и напоминания",
                title: "AI-бот и напоминания",
                subtitle: "Как бот отвечает в WhatsApp и когда уходят напоминания.",
                botEnabledLabel: "AI-бот записи",
                botEnabledOn: "Включён",
                botEnabledOff: "Отключён",
                languageLabel: "Язык ответов бота",
                reminderLeadLabel: "Заблаговременность напоминания",
                confirmationTimeoutLabel: "Таймаут подтверждения",
                templateNameLabel: "Имя шаблона WhatsApp",
                templateNameHelp: "Должно совпадать с зарегистрированным шаблоном в Meta (например whapiz_appointment_reminder).",
                signatureLabel: "Подпись бизнеса",
                saveBtn: "Сохранить настройки бота",
                savingBtn: "Сохранение...",
                savedToast: "Настройки бота сохранены",
                errors: {
                  templateNameRequired: "Имя шаблона обязательно — без него напоминания не уйдут."
                }
              },
              oauth: {
                successTitle: "Календарь подключён",
                successBody: "Всё готово",
                providerGoogle: "Google Calendar",
                providerMicrosoft: "Microsoft Outlook",
                errorTitle: "Ошибка подключения",
                errorBody: "Попробуйте ещё раз"
              }
            },
            internalChat: {
              title: "Внутренний чат",
              conversations: "Беседы",
              newChat: "Новый чат",
              editChat: "Редактировать чат",
              chatTitle: "Название чата",
              chatTitlePlaceholder: "Введите название чата...",
              passwordOptional: "Пароль (необязательно)",
              passwordPlaceholder: "Установите пароль для защиты чата",
              selectParticipants: "Выберите участников",
              cancel: "Отмена",
              create: "Создать",
              save: "Сохранить",
              confirm: "Подтвердить",
              delete: "Удалить",
              deleteChat: "Удалить чат",
              confirmDelete: "Вы уверены, что хотите удалить этот чат?",
              chatCreated: "Чат успешно создан",
              chatUpdated: "Чат успешно обновлён",
              chatDeleted: "Чат успешно удалён",
              error: "Произошла ошибка",
              titleRequired: "Введите название чата",
              usersRequired: "Выберите хотя бы одного участника",
              selectChat: "Выберите беседу",
              selectChatDesc: "Выберите чат из списка, чтобы начать общение",
              emptyActions: {
                newChat: "Новый чат",
                conversations: "Беседы",
                messages: "Сообщения"
              },
              noChats: "Пока нет бесед",
              noMessages: "Нет сообщений",
              startConversation: "Начать беседу",
              placeholder: "Введите сообщение...",
              download: "Скачать",
              yesterday: "Вчера",
              owner: "Владелец",
              participants: "Участники",
              showOwner: "Показать владельца",
              showUsers: "Показать участников",
              passwordRequired: "Требуется пароль",
              password: "Пароль",
              incorrectPassword: "Неверный пароль",
              passwordError: "Ошибка проверки пароля",
              chats: "Чаты",
              messages: "Сообщения",
              noChat: "Чат не выбран",
              addMember: "Добавить участника",
              add: "Добавить",
              memberAdded: "Участник успешно добавлен!",
              close: "Закрыть",
              saving: "Добавление...",
              changeColor: "Изменить цвет чата",
              eyebrow: "Команда",
              stats: {
                conversations: "Беседы"
              }
            },
            qrCode: {
              message: "Отсканируйте QR-код, чтобы начать сеанс"
            },
            templates: {
              title: "Шаблоны WhatsApp",
              syncButton: "Синхронизировать с Meta",
              syncFromMeta: "Синхронизировать с Meta",
              sync: "Синхронизация",
              syncing: "Синхронизация...",
              noTemplates: "Шаблоны не найдены. Нажмите 'Синхронизировать с Meta' для импорта.",
              syncNow: "Синхронизировать шаблоны",
              preview: "Предпросмотр",
              fillVariables: "Заполните переменные",
              lastSynced: "Последняя синхронизация",
              description: "Шаблоны — это заранее одобренные сообщения, которые можно отправлять клиентам после 24-часового окна. Создайте шаблоны в Meta Business Manager, затем нажмите 'Синхронизировать с Meta'.",
              connections: "Подключения WhatsApp Business",
              errors: {
                fillAllVariables: "Заполните все переменные",
                sendFailed: "Не удалось отправить шаблон",
                syncFailed: "Не удалось синхронизировать шаблоны"
              },
              success: {
                sent: "Шаблон успешно отправлен",
                synced: "Шаблоны успешно синхронизированы"
              },
              buttons: {
                send: "Отправить шаблон",
                cancel: "Отмена",
                sync: "Синхронизировать с Meta"
              },
              table: {
                name: "Название",
                language: "Язык",
                connection: "Подключение",
                status: "Статус",
                category: "Категория",
                active: "Активен",
                preview: "Предпросмотр"
              },
              categories: {
                utility: "Сервис",
                marketing: "Маркетинг",
                authentication: "Аутентификация"
              },
              active: "Активные",
              inactive: "Неактивные",
              refresh: "Обновить",
              stats: {
                total: "Всего",
                approved: "Одобрено",
                pending: "Ожидает",
                rejected: "Отклонено"
              }
            },
            gptMenu: {
              aiSuggestions: "AI Предложения",
              conversationSummary: "Сводка разговора",
              salesOpportunities: "Возможности продаж",
              sentimentAnalysis: "Анализ настроений",
              agentPerformance: "Производительность агента",
              keyIssues: "Ключевые проблемы"
            },
            gptSettings: {
              title: "GPT AI Помощник",
              subtitle: "AI-предложения для вашей команды поддержки",
              enableTitle: "Включить GPT Помощник",
              enableDescription: "AI-предложения появятся в разговорах тикетов",
              status: "Статус",
              apiKeyConfigured: "API ключ настроен",
              apiKeyMissing: "API ключ отсутствует",
              gptEnabled: "GPT включен",
              gptDisabled: "GPT отключен",
              currentModel: "Текущая модель",
              apiConfiguration: "Настройка API",
              aiModel: "AI Модель",
              openaiApiKey: "OpenAI API Ключ",
              getApiKey: "Получите API ключ на platform.openai.com",
              recommended: "Рекомендуется",
              responseTone: "Тон ответов",
              responseToneDescription: "Выберите стиль общения AI",
              advancedSettings: "Расширенные настройки",
              customPrompt: "Пользовательский промпт",
              customPromptPlaceholder: "Добавьте инструкции для AI...",
              customPromptHint: "Будет добавлено ко всем ответам AI",
              saveSettings: "Сохранить настройки",
              saving: "Сохранение...",
              saved: "Настройки сохранены.",
              loading: "Загрузка...",
              showAdvanced: "Показать дополнительные",
              hideAdvanced: "Скрыть дополнительные",
              statusDesc: "Текущее состояние AI-помощника",
              apiConfigDesc: "Ключ OpenAI и выбор модели",
              advancedDesc: "Пользовательский системный промпт"
            },
            aiDashboard: {
              title: "AI Дашборд",
              refresh: "Обновить",
              noData: "Нет данных",
              allAgents: "Все агенты",
              daysCount: "{{count}} дней",
              singleDay: "день",
              multiDay: "дней",
              kpi: {
                totalConversations: "Всего чатов",
                open: "Открыто",
                pending: "Ожидают",
                closed: "Закрыто",
                responseTime: "Время ответа",
                satisfaction: "Удовлетворённость",
                resolvedPct: "{{pct}}% решено",
                outOfFive: "из 5.0"
              },
              subtitle: {
                chats: "{{count}} чатов",
                activeAgents: "{{count}} активных агентов"
              },
              quickInsights: {
                loadSubtitle: "{{score}}/100 нагрузки",
                resolutionSubtitle: "{{closed}} из {{total}}",
                avgPerTicket: "среднее на тикет",
                noStats: "Нет данных",
                customerSatisfaction: "Удовлетворённость клиентов"
              },
              units: {
                minuteAbbr: "м",
                hourAbbr: "ч",
                dayAbbr: "д"
              },
              tabs: {
                overview: "Обзор",
                agentPerformance: "Производительность агентов",
                keyIssues: "Ключевые проблемы",
                sentimentTrends: "Тренды настроений",
                salesInsights: "Аналитика продаж",
                learning: "Обучение"
              },
              filters: {
                dateRange: "Период",
                last7days: "Последние 7 дней",
                last14days: "Последние 14 дней",
                last30days: "Последние 30 дней",
                last90days: "Последние 90 дней"
              },
              overview: {
                totalConversations: "Всего разговоров",
                avgResponseTime: "Среднее время ответа",
                resolutionRate: "Процент решения",
                satisfaction: "Удовлетворенность клиентов",
                aiPerformance: "Производительность AI",
                suggestionsUsed: "Использовано AI предложений",
                aiAccuracy: "Точность AI",
                activeAgents: "Активные агенты",
                pendingTickets: "Ожидающие тикеты",
                workload: "Нагрузка",
                openTickets: "Открытые тикеты",
                ticketsPerAgent: "Тикетов на агента",
                workloadLevel: "Уровень нагрузки",
                systemStatus: "Статус системы",
                closedToday: "Закрыто сегодня"
              },
              status: {
                normal: "Нормально",
                moderate: "Умеренная нагрузка",
                highLoad: "Высокая нагрузка",
                quickInsights: "Быстрая аналитика"
              },
              insights: {
                peakHours: "Часы пик",
                peakHoursDesc: "Большинство разговоров происходит с 10:00 до 14:00",
                topPerformer: "Лучший агент",
                topPerformerDesc: "По времени ответа и проценту решения"
              },
              agentPerformance: {
                selectAgent: "Выберите агента",
                allAgents: "Все агенты",
                responseTime: "Среднее время ответа",
                ticketsHandled: "Обработано тикетов",
                qualityScore: "Оценка качества",
                detailedAnalysis: "Детальный анализ",
                workload: "Загрузка",
                politenessScore: "Оценка вежливости",
                aiRecommendations: "Рекомендации AI",
                firstResponse: "Первый ответ",
                missedMessages: "Пропущенные сообщения",
                ticketsResolved: "Решённые тикеты",
                sentimentTrend: "Тренд настроения",
                confusionCases: "Случаи путаницы",
                recoveryRate: "Процент восстановления",
                resolutionRate: "Процент решения",
                improving: "Улучшается",
                declining: "Ухудшается",
                stable: "Стабильно"
              },
              keyIssues: {
                title: "Обнаруженные проблемы",
                subtitle: "Проблемы выявленные в разговорах с клиентами",
                occurrences: "случаев",
                lastSeen: "Последний раз",
                noIssues: "Критических проблем не обнаружено",
                unknownIssue: "Неизвестная проблема",
                ticketsAffected: "затронуто тикетов",
                patterns: "Общие паттерны",
                recommendations: "Рекомендации"
              },
              sentiment: {
                positive: "Позитивный",
                neutral: "Нейтральный",
                negative: "Негативный",
                trends: "Тренды настроений",
                trendsDescription: "Отслеживайте настроения клиентов для выявления паттернов",
                trend: "Тренд",
                messagesAnalyzed: "Проанализировано сообщений",
                topPositiveKeywords: "Позитивные ключевые слова",
                topNegativeKeywords: "Негативные ключевые слова",
                improving: "Улучшается",
                declining: "Ухудшается",
                stable: "Стабильно"
              },
              salesInsights: {
                title: "Возможности продаж",
                upsellOpportunities: "Возможности апсейла",
                upsellDescription: "Разговоры с потенциалом дополнительных продаж",
                conversionRate: "Конверсия",
                conversionDescription: "Лиды конвертированные в успешные бронирования",
                totalOpportunities: "Всего возможностей",
                revenuePotential: "Потенциал дохода",
                upsellCrossSell: "Апсейл + Кросс-продажи",
                opportunitiesByType: "Возможности по типу",
                upsell: "Апсейл",
                crossSell: "Кросс-продажи",
                newProduct: "Новый продукт",
                topProductsMentioned: "Популярные продукты",
                noProductsDetected: "Продукты не обнаружены",
                recentOpportunities: "Недавние возможности"
              }
            },
            whatsappModal: {
              title: {
                add: "Добавить WhatsApp",
                edit: "Редактировать WhatsApp"
              },
              form: {
                name: "Название",
                default: "По умолчанию",
                channel: "Канал",
                channelDescription: "Выберите, использовать Baileys (QR-код) или официальный Meta Business API.",
                token: "Токен доступа Meta",
                tokenDescription: "Вставьте постоянный токен System User, который предоставила Meta.",
                defaultDisabled: "По умолчанию можно выбирать только Baileys-подключения.",
                channelLabelTitle: "Метка канала",
                channelLabelDescription: "Добавьте метку для идентификации этого номера в чатах (например: Сайт, Основной, Поддержка)",
                channelLabel: "Метка",
                channelLabelColor: "Цвет"
              },
              channelOptions: {
                whatsapp: "WhatsApp Web (Baileys)",
                business: "Meta Business API"
              },
              buttons: {
                okAdd: "Добавить",
                okEdit: "Сохранить",
                cancel: "Отмена"
              },
              success: "Подключение WhatsApp успешно сохранено."
            },
            dashboard: {
              title: "Панель управления WhatsApp CRM",
              unassigned: "Без назначения",
              others: "Другие",
              other: "Другое",
              status: {
                open: "Открыт",
                pending: "Ожидает",
                closed: "Закрыт",
                unknown: "Неизвестно",
                online: "Онлайн",
                offline: "Не в сети"
              },
              charts: {
                perDay: {
                  title: "Сегодняшние обращения: "
                },
                filters: {
                  button: "Фильтровать",
                  startDate: "Дата начала",
                  endDate: "Дата окончания",
                  periodText: "Период",
                  periodOptions: {
                    input: "Выберите нужный период",
                    zero: "Период не выбран",
                    three: "Последние 3",
                    seven: "Последние 7",
                    fifteen: "Последние 15",
                    thirty: "Последние 30",
                    sixty: "Последние 60",
                    ninety: "Последние 90"
                  },
                  choosePeriod: "Выберите нужный период",
                  selectError: "Выберите хотя бы один параметр фильтрации.",
                  quickRanges: {
                    day: "День",
                    threeDays: "3 дня",
                    week: "Неделя",
                    twoWeeks: "2 недели",
                    month: "Месяц",
                    threeMonths: "3 месяца",
                    all: "За всё время"
                  },
                  duedate: "Срок",
                  filtertype: {
                    title: "Тип фильтра",
                    valueA: "Фильтр по дате",
                    valueB: "Фильтр по периоду",
                    helperText: "Выберите нужный период"
                  }
                },
                noData: "Нет данных для отображения",
                dayNames: {
                  full: [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ],
                  short: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]
                },
                titles: {
                  tagsDistribution: "Заявки по тегам",
                  statusDistribution: "Новые заявки по статусу",
                  queueDistribution: "Заявки по очередям",
                  userDistribution: "Заявки по сотрудникам",
                  dayDistribution: "Заявки по дням недели",
                  messagesToday: "Сообщения, полученные сегодня",
                  newMessagesReceived: "Новые полученные сообщения"
                }
              },
              cards: {
                attdPendants: "Заявки в ожидании",
                attdHappening: "Активные заявки",
                attdPerformed: "Закрытые заявки",
                attdWaiting: "Заявки в очереди",
                leads: "Лиды",
                mtofService: "Среднее время обработки",
                mtofwaiting: "Среднее время ожидания",
                total: "Всего заявок"
              },
              gptAnalytics: {
                title: "AI Аналитика",
                refresh: "Обновить аналитику",
                refreshed: "Аналитика обновлена",
                error: "Ошибка загрузки аналитики",
                noData: "Нет данных для анализа",
                resolutionRate: "Решено",
                avgResponseTime: "Ср. время ответа",
                activeTickets: "Активные",
                waitingTickets: "Ожидают",
                overallSentiment: "Общий анализ настроений",
                aiInsights: "AI Инсайты",
                showMore: "Показать больше",
                showLess: "Показать меньше",
                topPerformer: "Лучший сотрудник",
                closed: "закрыто",
                queueDistribution: "Распределение по очередям",
                lastUpdated: "Обновлено",
                insights: {
                  highResolution: "Отличный показатель решений!",
                  lowResolution: "Показатель решений требует улучшения",
                  manyPending: "Много заявок ожидают ответа",
                  ticketsClosed: "заявок закрыто",
                  slowResponse: "Время ответа выше среднего",
                  fastResponse: "Быстрое время ответа!"
                }
              },
              table: {
                name: "Имя",
                calif: "Оценки",
                total: "Всего",
                current: "Активные заявки",
                closed: "Закрытые заявки",
                timemedia: "Среднее время обработки",
                waiting: "Среднее время ожидания",
                statuschat: "Текущий статус",
                openCalls: "Открытые звонки",
                closedCalls: "Закрытые звонки",
                totalCalls: "Всего звонков",
                connected: "Подключен",
                disconnected: "Отключен",
                newCallsByDate: "Новые звонки по дате",
                status: "Статус",
                tickets: "Заявки",
                avgHandle: "Среднее время обработки",
                rating: "Рейтинг",
                section: "Вкладка",
                avgHandleTime: "Среднее время обработки",
                closeRate: "Процент закрытия",
                openCount: "Открытые",
                avgWait: "Время ожидания"
              },
              tooltip: {
                ticketsCount: "{{count}} заявок"
              },
              ticketsByHour: {
                title: "Заявки по часам",
                formatButton: "Формат: {{value}}",
                formatOptions: {
                  twelve: "12 ч",
                  twentyFour: "24 ч"
                },
                chartTypes: {
                  bar: "Столбцы",
                  line: "Линия",
                  area: "Площадь"
                },
                legend: {
                  businessHours: "Рабочие часы (09:00–18:00)",
                  outOfHours: "Вне рабочего времени"
                },
                stats: {
                  title: "Почасовая статистика",
                  peakHour: "Час пик",
                  peakHourCount: "{{count}} заявок",
                  businessHours: "Рабочие часы",
                  businessHoursSuffix: "от общего количества заявок",
                  outOfHours: "Вне рабочего времени",
                  outOfHoursSuffix: "от общего количества заявок",
                  averagePerHour: "Среднее за час",
                  averagePerHourSuffix: "заявок в час"
                },
                seriesName: "Заявки"
              },
              subtitle: "Живой снимок работы команды",
              greet: {
                morning: "Доброе утро",
                afternoon: "Добрый день",
                evening: "Добрый вечер",
                night: "Спокойной ночи"
              },
              range: {
                today: "Сегодня",
                yesterday: "Вчера",
                "7d": "7 дней",
                "30d": "30 дней",
                "90d": "90 дней",
                custom: "Произвольный"
              },
              trend: {
                vsPrev: "по сравнению с пред."
              },
              role: {
                admin: "Админ",
                supervisor: "Супервизор",
                agent: "Агент"
              },
              filter: {
                label: "Фильтры",
                title: "Фильтр данных",
                queue: "Очередь",
                whatsapp: "Аккаунт WhatsApp",
                agent: "Агент",
                all: "Все",
                clear: "Очистить фильтры",
                from: "С",
                to: "По"
              },
              breadcrumb: {
                home: "Главная",
                dashboard: "Панель"
              },
              pulse: {
                systemStable: "Система стабильна",
                activeChats: "активных чатов",
                onlineAgents: "агентов онлайн",
                activeNow: "активных диалогов сейчас"
              },
              kpi: {
                newMessages: "Новые сообщения",
                open: "Открытые",
                pending: "Ожидают",
                inProgress: "В обработке",
                closed: "Закрытые",
                newCustomers: "Новые клиенты",
                totalTickets: "Всего обращений",
                uniqueCustomers: "Уникальные клиенты",
                messagesReceived: "Полученные сообщения"
              },
              panel: {
                messagesToday: "Сообщения сегодня",
                messagesRange: "Сообщения за {{periodLabel}}",
                ticketsByStatus: "Заявки по статусу",
                ticketsByHour: "Заявки по часам",
                generalStats: "Общая статистика",
                agents: "Агенты",
                sections: "Тикеты по пользовательским вкладкам",
                sectionsSub: "Распределение по пользовательским tag-фильтрам",
                inPeriod: "за выбранный период"
              },
              donut: {
                total: "Всего заявок"
              },
              metric: {
                avgHandle: "Среднее время обработки",
                avgWait: "Среднее время ответа",
                totalTickets: "Всего заявок",
                uniqueTickets: "Уникальных заявок",
                messagesSent: "Отправленные сообщения"
              },
              agents: {
                empty: "Нет данных по агентам"
              },
              unit: {
                messages: "сообщений",
                tickets: "заявок"
              }
            },
            plansManager: {
              form: {
                name: "Название тарифа",
                isPublic: "Доступен для всех",
                value: "Цена",
                users: "Пользователи",
                connections: "Подключения",
                queues: "Очереди",
                options: {
                  yes: "Да",
                  no: "Нет"
                },
                buttons: {
                  clear: "Очистить",
                  delete: "Удалить",
                  save: "Сохранить"
                }
              },
              table: {
                name: "Название",
                users: "Пользователи",
                isPublic: "Доступ",
                connections: "Подключения",
                queues: "Очереди",
                value: "Цена"
              },
              toasts: {
                loadError: "Не удалось загрузить список тарифов.",
                success: "Операция успешно выполнена!",
                saveError: "Не удалось выполнить операцию. Проверьте, не существует ли тариф с таким именем и корректно ли заполнены поля.",
                deleteError: "Не удалось выполнить операцию."
              },
              confirmation: {
                title: "Подтверждение удаления",
                message: "Вы уверены, что хотите удалить эту запись?"
              }
            },
            companiesManager: {
              form: {
                name: "Название",
                email: "E-mail",
                phone: "Телефон",
                plan: "Тариф",
                status: "Статус",
                expiration: "Дата истечения"
              },
              table: {
                name: "Название",
                email: "E-mail",
                phone: "Телефон",
                plan: "Тариф",
                status: "Статус",
                createdAt: "Создано",
                expiration: "Истечение"
              }
            },
            moveTicket: {
              button: "Переместить…",
              current: "текущий",
              status: {
                open: "Открытые",
                pending: "Ожидающие",
                closed: "Закрытые"
              }
            },
            mainDrawer: {
              search: "Поиск в меню…",
              listItems: {
                aiOs: "AI-OS — Мозг",
                dashboard: "Панель",
                connections: "Подключения",
                tickets: "Заявки",
                voiceIntelligence: "Voice Intelligence",
                appointments: "Записи",
                quickMessages: "Быстрые ответы",
                contacts: "Контакты",
                queues: "Очереди и чат-бот",
                tags: "Теги",
                toDoList: "Список задач",
                administration: "Администрирование",
                service: "Сервис",
                users: "Пользователи",
                settings: "Настройки",
                helps: "Помощь",
                about: "Лидеры продаж",
                messagesAPI: "API",
                schedules: "Запланированные задачи",
                files: "Файлы",
                campaigns: "Кампании",
                annoucements: "Объявления",
                chats: "Внутренний чат",
                financeiro: "Финансы",
                logout: "Выйти",
                management: "Управление",
                kanban: "Канбан",
                whatsappBackups: "Резервные копии WhatsApp",
                archive: "Архив",
                aiDashboard: "AI Дашборд",
                aiSettings: "Настройки AI",
                aiWorkforce: "AI Workforce",
                teams: "Команды",
                offers: "Каталог предложений",
                pipelines: "Пайплайны",
                billing: "Оплата"
              },
              role: {
                administrator: "Администратор",
                supervisor: "Супервайзер",
                agent: "Агент"
              },
              workspace: {
                admin: "Рабочее пространство администратора",
                supervisor: "Рабочее пространство супервайзера",
                default: "Рабочее пространство"
              },
              appBar: {
                backToAdmin: "К администрированию",
                i18n: {
                  language: "Русский",
                  language_short: "RU"
                },
                greetings: {
                  one: "Здравствуйте",
                  two: "Добро пожаловать в"
                },
                user: {
                  profile: "Профиль",
                  darkmode: "Тёмная тема",
                  lightmode: "Светлая тема",
                  language: "Выберите язык",
                  logout: "Выйти"
                },
                notRegister: "Нет внутренних чатов"
              }
            },
            contacts: {
              title: "Контакты",
              whatsappUser: "Пользователь WhatsApp",
              toasts: {
                deleted: "Контакт успешно удалён!"
              },
              searchPlaceholder: "Поиск...",
              confirmationModal: {
                deleteTitle: "Удалить ",
                importTitlte: "Импорт контактов",
                deleteMessage: "Вы уверены, что хотите удалить этот контакт? Все связанные взаимодействия будут потеряны.",
                importMessage: "Вы хотите импортировать все контакты с телефона?"
              },
              buttons: {
                import: "Импорт контактов",
                add: "Добавить контакт"
              },
              table: {
                name: "Имя",
                whatsapp: "WhatsApp",
                email: "Email",
                phone: "Телефон",
                actions: "Действия"
              }
            },
            contactModal: {
              title: {
                add: "Добавить контакт",
                edit: "Редактировать контакт"
              },
              form: {
                mainInfo: "Информация о контакте",
                extraInfo: "Дополнительная информация",
                name: "Имя",
                number: "Номер WhatsApp",
                email: "Email",
                extraName: "Название поля",
                extraValue: "Значение",
                disableBot: "Отключить чат-бота"
              },
              buttons: {
                addExtraInfo: "Добавить информацию",
                okAdd: "Добавить",
                okEdit: "Сохранить",
                cancel: "Отмена"
              },
              success: "Контакт успешно сохранён."
            },
            users: {
              title: "Пользователи",
              table: {
                name: "Имя",
                email: "Email",
                profile: "Профиль",
                actions: "Действия",
                lastLogin: "Последний вход"
              },
              buttons: {
                add: "Добавить пользователя"
              },
              toasts: {
                deleted: "Пользователь успешно удалён."
              },
              confirmationModal: {
                deleteTitle: "Удалить",
                deleteMessage: "Все данные пользователя будут потеряны. Открытые тикеты этого пользователя будут перемещены в очередь."
              },
              role: {
                admin: "Администратор",
                supervisor: "Супервизор",
                user: "Пользователь"
              },
              status: {
                online: "В сети",
                offline: "Не в сети"
              },
              activity: {
                title: "Активность пользователя",
                filters: {
                  today: "Сегодня",
                  last7: "Последние 7 дней",
                  last14: "Последние 14 дней",
                  last21: "Последние 21 день",
                  last30: "Последние 30 дней",
                  month: "Конкретный месяц"
                },
                kpis: {
                  lastLogin: "Последний вход",
                  totalLogins: "Всего входов",
                  totalConnected: "Общее время подключения",
                  totalActive: "Общее активное время",
                  totalIdle: "Общее время простоя",
                  avgSession: "Средняя длительность сессии",
                  avgDaily: "Средняя дневная активность"
                },
                sessions: {
                  title: "Детали сессий",
                  date: "Дата",
                  login: "Вход",
                  logout: "Выход",
                  duration: "Длительность",
                  active: "Активно",
                  idle: "Простой",
                  actions: "Действия",
                  noData: "Нет данных об активности за выбранный период",
                  stillActive: "Активен"
                }
              }
            },
            userModal: {
              title: {
                add: "Добавить пользователя",
                edit: "Редактировать пользователя"
              },
              form: {
                name: "Имя",
                email: "Email",
                password: "Пароль",
                profile: "Профиль",
                sales: "Продажи",
                salesHelp: "Ручной счётчик, отображаемый в рейтинге.",
                currency: "Валюта"
              },
              buttons: {
                okAdd: "Добавить",
                okEdit: "Сохранить",
                save: "Сохранить",
                cancel: "Отмена"
              },
              success: "Пользователь успешно сохранён."
            },
            queues: {
              title: "Очереди и чат-бот",
              table: {
                name: "Название",
                color: "Цвет",
                greeting: "Приветственное сообщение",
                actions: "Действия"
              },
              buttons: {
                add: "Добавить очередь"
              },
              confirmationModal: {
                deleteTitle: "Удалить",
                deleteMessage: "Вы уверены? Это действие нельзя отменить! Тикеты из этой очереди останутся, но больше не будут назначены ни одной очереди."
              }
            },
            aiWorkforce: {
              title: "AI Персонал",
              refresh: "Обновить",
              enabled: "Активен",
              disabled: "Отключен",
              stats: {
                activeAgents: "Активные агенты",
                knowledgeItems: "Элементы знаний",
                businessRules: "Бизнес-правила",
                actionsToday: "Действия сегодня"
              },
              tabs: {
                agents: "AI Агенты",
                knowledge: "База знаний",
                rules: "Бизнес-правила",
                logs: "Журнал действий"
              },
              agents: {
                title: "Настройка AI агентов",
                addAgent: "Добавить агента",
                createTitle: "Создать агента",
                editTitle: "Редактировать агента",
                name: "Имя агента",
                role: "Роль",
                model: "Модель GPT",
                temperature: "Температура",
                maxTokens: "Макс. токенов",
                systemPrompt: "Системный промпт (опционально)",
                agentEnabled: "Агент включен",
                test: "Тест",
                testAgent: "Тест агента",
                runningTest: "Выполняется тест...",
                testSuccess: "Тест успешно завершен",
                result: "Результат",
                noAgents: "Нет AI агентов",
                noAgentsDesc: "Создайте первого AI агента для автоматизации процессов",
                deleteConfirm: "Вы уверены, что хотите удалить этого агента?",
                created: "Агент успешно создан",
                updated: "Агент успешно обновлен",
                deleted: "Агент удален",
                roles: {
                  conversation: "Агент разговора",
                  queue_manager: "Менеджер очередей",
                  process_finisher: "Завершитель процессов",
                  offer_matcher: "Подбор предложений",
                  pricing_calculator: "Калькулятор цен",
                  promotion_engine: "Двигатель акций",
                  supervisor: "Супервайзер",
                  business_intelligence: "Бизнес-аналитика",
                  scheduling_manager: "Менеджер расписаний",
                  notification_engine: "Система уведомлений"
                },
                models: {
                  gpt4o: "GPT-4o (Рекомендуется)",
                  gpt4turbo: "GPT-4 Turbo",
                  gpt35turbo: "GPT-3.5 Turbo (Быстрее)"
                },
                temperatureLabels: {
                  precise: "Точный",
                  creative: "Креативный"
                }
              },
              knowledge: {
                title: "База знаний",
                add: "Добавить",
                createTitle: "Добавить знание",
                editTitle: "Редактировать знание",
                titleField: "Название",
                content: "Содержание",
                type: "Тип",
                active: "Активно",
                inactive: "Неактивно",
                updated: "Обновлено",
                search: "Поиск...",
                noKnowledge: "Нет записей знаний",
                noKnowledgeDesc: "Добавьте продукты, FAQ и политики для использования AI",
                deleteConfirm: "Удалить эту запись знаний?",
                created: "Знание создано",
                updatedMsg: "Знание обновлено",
                deleted: "Знание удалено",
                types: {
                  product: "Продукт",
                  faq: "FAQ",
                  policy: "Политика",
                  general: "Общее",
                  supplier: "Поставщик",
                  destination: "Направление"
                }
              },
              rules: {
                title: "Бизнес-правила",
                addRule: "Добавить правило",
                createTitle: "Добавить правило",
                editTitle: "Редактировать правило",
                name: "Название правила",
                type: "Тип",
                description: "Описание",
                priority: "Приоритет",
                conditions: "Условия (JSON)",
                actions: "Действия (JSON)",
                active: "Активно",
                inactive: "Неактивно",
                noRules: "Нет бизнес-правил",
                noRulesDesc: "Настройте правила ценообразования, маршрутизации и эскалации",
                deleteConfirm: "Удалить это правило?",
                created: "Правило создано",
                updated: "Правило обновлено",
                deleted: "Правило удалено",
                types: {
                  pricing: "Ценообразование",
                  promotion: "Акция",
                  routing: "Маршрутизация",
                  escalation: "Эскалация",
                  commission: "Комиссия",
                  general: "Общее"
                },
                keywordsHelper: "напр. отмена, стоп, менеджер"
              },
              logs: {
                title: "Журнал действий AI",
                noLogs: "Нет логов",
                noLogsDesc: "Действия AI появятся здесь",
                ticket: "Тикет"
              },
              common: {
                save: "Сохранить",
                cancel: "Отмена",
                close: "Закрыть",
                all: "Все",
                name: "Название",
                status: "Статус",
                actions: "Действия",
                edit: "Редактировать",
                delete: "Удалить"
              }
            },
            offers: {
              title: "Каталог предложений",
              newOffer: "Новое предложение",
              searchPlaceholder: "Поиск предложений...",
              stats: {
                total: "Всего предложений",
                active: "Активные",
                featured: "Избранные"
              },
              source: {
                label: "Источник",
                all: "Все источники",
                internal: "Внутренние",
                external: "Raviv API",
                offerDetails: "Детали предложения"
              },
              table: {
                offer: "Предложение",
                destination: "Направление",
                duration: "Продолжительность",
                price: "Цена",
                status: "Статус",
                featured: "Избранное",
                actions: "Действия",
                nights: "ночей",
                active: "Активно",
                inactive: "Неактивно"
              },
              modal: {
                createTitle: "Создать предложение",
                editTitle: "Редактировать предложение",
                sections: {
                  basicInfo: "Основная информация",
                  destination: "Направление",
                  datesDuration: "Даты и продолжительность",
                  pricing: "Цены",
                  accommodation: "Проживание",
                  flight: "Перелёт (необязательно)",
                  images: "Изображения",
                  status: "Статус"
                },
                fields: {
                  title: "Название",
                  titlePlaceholder: "например, Романтический Париж",
                  type: "Тип",
                  description: "Описание",
                  descriptionPlaceholder: "Опишите, что делает это предложение особенным...",
                  destination: "Направление",
                  destinationPlaceholder: "например, Париж",
                  country: "Страна",
                  countryPlaceholder: "например, Франция",
                  validFrom: "Действительно с",
                  validTo: "Действительно до",
                  days: "Дней",
                  nights: "Ночей",
                  basePrice: "Базовая цена",
                  currency: "Валюта",
                  childPrice: "Детская цена",
                  markup: "Наценка %",
                  hotelName: "Название отеля",
                  stars: "Звёзды",
                  board: "Питание",
                  airline: "Авиакомпания",
                  departureCity: "Город вылета",
                  compositionPricing: "Цены по составу группы (итого за группу)",
                  compositionPricingHint: "Укажите общие цены для каждого состава семьи. Оставьте пустым для расчёта: базовая цена × кол-во путешественников.",
                  pricingCouple: "Пара",
                  pricingCouple1Child: "Пара + 1 ребёнок",
                  pricingCouple2Children: "Пара + 2 ребёнка",
                  pricingCouple3Children: "Пара + 3 ребёнка",
                  pricingSingle: "Один путешественник",
                  pricing3Adults: "3 взрослых",
                  pricing3Adults1Child: "3 взрослых + 1 ребёнок",
                  pricing3Adults2Children: "3 взрослых + 2 ребёнка"
                },
                boardTypes: {
                  none: "Нет",
                  roomOnly: "Только номер",
                  bedBreakfast: "Завтрак включён",
                  halfBoard: "Полупансион",
                  fullBoard: "Полный пансион",
                  allInclusive: "Всё включено"
                },
                types: {
                  package: "Пакет",
                  flight: "Перелёт",
                  hotel: "Отель",
                  tour: "Тур",
                  cruise: "Круиз",
                  custom: "Особый"
                },
                active: "Активно",
                activeDescription: "Видно клиентам",
                featured: "Избранное",
                featuredDescription: "Выделено в списках",
                cancel: "Отмена",
                create: "Создать",
                save: "Сохранить"
              },
              images: {
                title: "Добавьте изображения для предложения",
                hint: "Качественные фото увеличивают бронирования на 40%",
                uploadNew: "Загрузить",
                browseLibrary: "Из библиотеки",
                uploading: "Загрузка..."
              },
              mediaBrowser: {
                title: "Выбрать из медиатеки",
                selected: "изображений выбрано",
                clickToSelect: "Нажмите на изображения для выбора",
                loading: "Загрузка файлов...",
                noFiles: "Файлы не найдены",
                noFilesHint: "Сначала загрузите изображения",
                cancel: "Отмена",
                addImages: "Добавить"
              },
              empty: {
                title: "Пока нет предложений",
                description: "Создайте первое предложение",
                createFirst: "Создать первое"
              },
              delete: {
                title: "Удалить предложение",
                confirm: "Вы уверены, что хотите удалить",
                warning: "Это действие нельзя отменить."
              },
              toast: {
                created: "Предложение создано!",
                updated: "Предложение обновлено!",
                deleted: "Предложение удалено"
              }
            },
            queueModal: {
              title: {
                add: "Добавить очередь",
                edit: "Редактировать очередь"
              },
              form: {
                name: "Имя",
                color: "Цвет",
                greetingMessage: "Приветственное сообщение",
                complationMessage: "Сообщение о завершении",
                outOfHoursMessage: "Сообщение вне рабочих часов",
                ratingMessage: "Сообщение об оценке",
                transferMessage: "Сообщение о переводе",
                token: "Токен"
              },
              buttons: {
                okAdd: "Добавить",
                okEdit: "Сохранить",
                cancel: "Отмена",
                attach: "Прикрепить файл",
                edit: "Редактировать",
                duplicate: "Дублировать"
              },
              options: {
                title: "Опции",
                notDefined: "Заголовок не определен",
                message: "Введите текст опции",
                note: {
                  title: "Добавьте опции для создания чат-бота",
                  content: "Если есть только одна опция, она будет выбрана автоматически, и бот ответит сообщением этой опции и продолжит"
                },
                addOpts: "Добавить опции",
                attendant: "Перевести на:"
              },
              confirmationModal: {
                deleteTitle: "Удалить вложение",
                deleteMessage: "Вы уверены, что хотите удалить это вложение?",
                deleteOptionTitle: "Удалить вопрос бота",
                deleteOptionMessage: "Вы уверены, что хотите удалить этот вопрос бота? Это действие нельзя отменить."
              }
            },
            tags: {
              title: "Теги",
              confirmationModal: {
                deleteTitle: "Вы уверены, что хотите удалить этот тег?",
                deleteMessage: "Это действие нельзя отменить."
              },
              table: {
                name: "Название",
                color: "Цвет",
                tickets: "Записи",
                actions: "Действия",
                id: "ID",
                kanban: "Канбан"
              },
              buttons: {
                add: "Новый тег"
              },
              toasts: {
                deleted: "Тег успешно удалён."
              }
            },
            tagModal: {
              title: {
                add: "Новый тег",
                edit: "Редактировать тег",
                addKanban: "Новая дорожка",
                editKanban: "Редактировать дорожку"
              },
              form: {
                name: "Название",
                color: "Цвет",
                kanban: "Канбан"
              },
              buttons: {
                okAdd: "Добавить",
                okEdit: "Сохранить",
                cancel: "Отмена"
              },
              success: "Тег успешно сохранён.",
              successKanban: "Дорожка успешно сохранена."
            },
            schedules: {
              title: "Расписания",
              confirmationModal: {
                deleteTitle: "Вы уверены, что хотите удалить это расписание?",
                deleteMessage: "Это действие нельзя отменить."
              },
              table: {
                contact: "Контакт",
                body: "Сообщение",
                sendAt: "Дата планирования",
                sentAt: "Дата отправки",
                status: "Статус",
                actions: "Действия",
                statusMap: {
                  PENDENTE: "Ожидает",
                  AGENDADA: "Запланировано",
                  ENVIADA: "Отправлено",
                  ERRO: "Ошибка"
                }
              },
              tabs: {
                all: "Все",
                active: "Активные",
                done: "Выполненные",
                noResults: "Нет задач в этой категории"
              },
              buttons: {
                add: "Новое расписание"
              },
              toasts: {
                deleted: "Расписание успешно удалено."
              },
              empty: {
                title: "Расписаний пока нет",
                desc: "Запланируйте сообщения заранее и отправляйте их клиентам в нужный момент — не нужно помнить или быть онлайн."
              }
            },
            scheduleModal: {
              title: {
                add: "Новое расписание",
                edit: "Редактировать расписание",
                error: "Ошибка отправки",
                message: "Сообщение"
              },
              form: {
                body: "Сообщение",
                contact: "Контакт",
                sendAt: "Дата расписания",
                sentAt: "Дата отправки",
                saveMessage: "Сохранить сообщение в тикете"
              },
              buttons: {
                okAdd: "Добавить",
                okEdit: "Сохранить",
                cancel: "Отмена"
              },
              success: "Расписание успешно сохранено."
            },
            tickets: {
              title: "Тикеты чата",
              toasts: {
                deleted: "Тикет, над которым вы работали, был удалён."
              },
              notification: {
                message: "Сообщение от"
              },
              tabs: {
                open: {
                  title: "Открытые"
                },
                closed: {
                  title: "Решённые"
                },
                search: {
                  title: "Поиск"
                }
              },
              search: {
                placeholder: "Поиск по имени, телефону или тексту..."
              },
              buttons: {
                showAll: "Все"
              }
            },
            ticketsQueueSelect: {
              placeholder: "Очереди"
            },
            ticketsList: {
              pendingHeader: "Ожидающие",
              assignedHeader: "В работе",
              noTicketsTitle: "Ничего здесь нет!",
              noTicketsMessage: "Не найдено тикетов с этим статусом или поисковым запросом",
              noQueue: "Без очереди",
              buttons: {
                accept: "Принять",
                close: "Закрыть"
              },
              items: {
                tags: "Теги"
              }
            },
            quickMessages: {
              title: "Быстрые ответы",
              table: {
                shortcut: "Ярлык",
                message: "Сообщение",
                actions: "Действия"
              },
              buttons: {
                add: "Новый ответ",
                save: "Сохранить"
              },
              dialog: {
                shortcode: "Ярлык",
                message: "Ответ"
              },
              confirmationModal: {
                delete: "Удалить",
                message: "Вы уверены, что хотите удалить этот быстрый ответ?"
              },
              toasts: {
                deleted: "Быстрый ответ успешно удалён."
              },
              empty: {
                title: "Быстрых ответов пока нет",
                desc: "Создайте готовые ответы, которые можно отправлять одним касанием при общении с клиентами. Экономит время на каждом обращении и поддерживает единый стиль команды.",
                cta: "Создать первый быстрый ответ"
              },
              samples: {
                welcome: "Здравствуйте! Добро пожаловать в GoDeal. Я здесь, чтобы помочь — чем могу быть полезен сегодня? 👋",
                hours: "Часы работы: Вс–Чт 09:00–18:00, Пт 09:00–13:00.",
                thanks: "Спасибо за обращение! Скоро вернусь с развёрнутым ответом. 🙏"
              }
            },
            announcements: {
              title: "Объявления",
              searchPlaceholder: "Поиск",
              noRecords: "Нет объявлений",
              empty: {
                title: "Активных объявлений нет",
                desc: "Внутренние сообщения, видимые всей команде — идеально для обновлений правил, организационных изменений и важных уведомлений."
              },
              priority: {
                high: "Высокий",
                medium: "Средний",
                low: "Низкий"
              },
              status: {
                active: "Активно",
                inactive: "Неактивно"
              },
              buttons: {
                add: "Новое объявление",
                contactLists: "Списки объявлений"
              },
              dialog: {
                edit: "Редактирование объявления",
                add: "Новое объявление",
                update: "Редактировать",
                readonly: "Только просмотр",
                form: {
                  priority: "Приоритет",
                  title: "Название",
                  text: "Текст",
                  mediaPath: "Файл",
                  status: "Статус"
                },
                buttons: {
                  add: "Добавить",
                  edit: "Обновить",
                  okadd: "Ок",
                  cancel: "Отменить объявления",
                  close: "Закрыть",
                  attach: "Прикрепить файл"
                }
              },
              table: {
                priority: "Приоритет",
                title: "Название",
                text: "Текст",
                mediaName: "Файл",
                status: "Статус",
                actions: "Действия"
              },
              confirmationModal: {
                deleteTitle: "Удалить",
                deleteMessage: "Это действие нельзя отменить."
              },
              toasts: {
                success: "Объявление успешно сохранено!",
                deleted: "Объявление успешно удалено!"
              }
            },
            files: {
              title: "Каталог файлов",
              preview: "Предпросмотр файла",
              notImage: "Этот файл не является изображением",
              download: "Скачать файл",
              table: {
                name: "Название",
                contacts: "Контакты",
                actions: "Действия",
                view: "Просмотр файла"
              },
              toasts: {
                deleted: "Файл успешно удален!",
                deletedAll: "Все файлы успешно удалены!"
              },
              buttons: {
                add: "Добавить",
                deleteAll: "Удалить все"
              },
              confirmationModal: {
                deleteTitle: "Удалить",
                deleteAllTitle: "Удалить все",
                deleteMessage: "Вы уверены, что хотите удалить этот файл?",
                deleteAllMessage: "Вы уверены, что хотите удалить все файлы?"
              },
              empty: {
                title: "Списков файлов пока нет",
                desc: "Создайте готовые списки файлов и отправляйте их клиентам одним кликом — идеально для каталогов, презентаций и маркетинговых материалов."
              }
            },
            chat: {
              noTicketMessage: "Выберите тикет, чтобы начать чат.",
              welcomeBack: "С возвращением",
              tip1Title: "Выберите диалог",
              tip1Text: "Кликните на чат в списке, чтобы начать отвечать клиенту",
              tip2Title: "Быстрые ответы",
              tip2Text: "Используйте готовые быстрые ответы — экономьте время в каждой беседе",
              tip3Title: "Будьте первыми",
              tip3Text: "Ответ в течение 7 минут повышает удовлетворённость клиента на 32%"
            },
            whatsappBackups: {
              title: "Резервные копии WhatsApp",
              archive: "Архив",
              messages: "Сообщения",
              contacts: "Контакты",
              media: "Медиа",
              buttons: {
                upload: "Загрузить резервную копию",
                uploading: "Загрузка...",
                download: "Скачать",
                parse: "Разобрать",
                preview: "Предпросмотр чата",
                restore: "Восстановить",
                restoring: "Восстановление...",
                search: "Поиск",
                searching: "Поиск...",
                validate: "Проверить",
                delete: "Удалить",
                close: "Закрыть",
                cancel: "Отмена"
              },
              preview: {
                title: "Предпросмотр чата",
                loading: "Загрузка предпросмотра...",
                noData: "Нет данных для предпросмотра",
                dateRange: "Дата начала",
                participants: "Участники",
                showingMessages: "Показано {{shown}} из {{total}} сообщений",
                loadMore: "Загрузить ещё 200",
                loadAll: "Загрузить все"
              },
              confirmationModal: {
                deleteTitle: "Удалить резервную копию",
                deleteMessage: "Вы уверены, что хотите удалить эту резервную копию? Это действие нельзя отменить."
              },
              table: {
                fileName: "Имя файла",
                status: "Статус",
                size: "Размер",
                format: "Формат",
                messages: "Сообщения",
                contacts: "Контакты",
                phone: "Номер телефона",
                uploaded: "Загружено",
                actions: "Действия"
              },
              status: {
                uploaded: "Загружено",
                processing: "Обработка",
                parsed: "Разобрано",
                failed: "Ошибка",
                validated: "Проверено"
              },
              dragDrop: {
                title: "Перетащите файл резервной копии сюда",
                dropping: "Отпустите файл здесь",
                subtitle: "или нажмите для выбора файлов",
                formats: "Поддерживаемые форматы: .txt, .json, .html, .zip, .db, .crypt12-15"
              },
              helper: {
                restoreInfo: "Восстановленные диалоги появляются в Tickets → фильтр «Closed». Когда клиент снова пишет, последний тикет открывается автоматически и история остается в одном чате."
              },
              search: {
                title: "Поиск в архиве",
                byText: "Поиск по тексту",
                bySender: "Поиск по отправителю",
                byDate: "Поиск по дате",
                placeholder: "Поиск по имени или телефону",
                results: "Результаты поиска"
              },
              toasts: {
                uploadSuccess: "Резервная копия загружена успешно",
                uploadError: "Ошибка загрузки резервной копии",
                deleteSuccess: "Резервная копия удалена успешно",
                parseSuccess: "Резервная копия разобрана успешно",
                validateSuccess: "Резервная копия проверена успешно",
                restoreSuccess: "Резервная копия восстановлена успешно",
                restoreError: "Ошибка восстановления резервной копии"
              },
              filters: {
                statusLabel: "Статус",
                allStatuses: "Все статусы",
                phonePlaceholder: "Фильтр по номеру телефона"
              },
              restore: {
                title: "Восстановить резервную копию в чаты",
                description: "Это импортирует все сообщения из резервной копии в живые тикеты.",
                selectConnection: "Подключение WhatsApp",
                customerPhone: "Номер телефона клиента",
                customerPhoneHelper: "Введите номер телефона клиента из этого чата (с кодом страны, например 380936226260)",
                enterPhone: "Пожалуйста, введите номер телефона клиента",
                foundContact: "Найден контакт",
                customerInChat: "Клиент в чате",
                notFoundInContacts: "не найден в контактах, введите номер вручную",
                autoFilled: "Автозаполнено из найденного контакта. Можете изменить при необходимости.",
                file: "Файл",
                messages: "Сообщения",
                contacts: "Контакты"
              },
              mainTabs: {
                backups: "Резервные копии",
                history: "История восстановления"
              },
              offlineMode: {
                warning: "Вы офлайн. Показаны кэшированные данные."
              },
              history: {
                title: "История восстановления",
                empty: "История пока пуста",
                emptyHint: "Восстановленные диалоги появятся здесь",
                fileName: "Файл резервной копии",
                phone: "Телефон",
                contact: "Контакт",
                messages: "Сообщения",
                restoredAt: "Восстановлено",
                result: "Результат",
                success: "Успешно",
                failed: "Ошибка",
                clearHistory: "Очистить историю",
                cleared: "История очищена"
              }
            },
            messagesInput: {
              placeholderOpen: "Введите сообщение",
              placeholderClosed: "Откройте заново или примите этот тикет, чтобы отправить сообщение.",
              signMessage: "Подписать",
              replying: "Ответ",
              editing: "Редактирование",
              micRequiresHttps: "Голосовая запись требует защищённого соединения (HTTPS) и доступа к микрофону"
            },
            message: {
              edited: "Отредактировано",
              forwarded: "Переслано",
              from: "от"
            },
            contactDrawer: {
              header: "Информация о контакте",
              buttons: {
                edit: "Редактировать контакт"
              },
              extraInfo: "Другая информация",
              chatbotNotes: {
                title: "Заметки чат-бота"
              },
              travelRequest: {
                title: "Запрос на поездку",
                score: "балл",
                matchedOffers: "Подходящие предложения ({{count}})",
                fields: {
                  destination: "🌍 Направление",
                  country: "🗺️ Страна",
                  productType: "✈️ Тип",
                  familyComposition: "👨‍👩‍👧 Состав",
                  adults: "🧑 Взрослые",
                  children: "👶 Дети",
                  childrenAges: "🎂 Возраст",
                  checkInDate: "📅 Заезд",
                  checkOutDate: "📅 Выезд",
                  nights: "🌙 Ночи",
                  boardBasis: "🍽️ Питание",
                  budget: "💰 Бюджет",
                  currency: "💱 Валюта",
                  preferences: "⭐ Предпочтения"
                },
                board: {
                  all_inclusive: "Всё включено",
                  full_board: "Полный пансион",
                  half_board: "Полупансион",
                  bed_breakfast: "Завтрак",
                  room_only: "Без питания"
                },
                product: {
                  flight_hotel: "Перелёт + отель",
                  flight_only: "Только перелёт",
                  hotel_only: "Только отель"
                }
              }
            },
            ticketOptionsMenu: {
              schedule: "Расписание",
              delete: "Удалить",
              transfer: "Передать",
              confirmationModal: {
                title: "Удалить тикет контакта",
                message: "Внимание! Все сообщения, связанные с тикетом, будут потеряны."
              },
              buttons: {
                delete: "Удалить",
                cancel: "Отмена"
              },
              scheduleAppointment: "📅 Записать клиента",
              appointmentTriggering: "Запуск бота записи…",
              appointmentTriggered: "Бот записи запущен — приветствие отправлено.",
              resetChatbot: "🔄 Сбросить бота",
              requestPayment: "💳 Запросить оплату",
              mergeBackup: "Импорт истории",
              downloadConversation: "📥 Скачать разговор",
              downloading: "Загрузка...",
              registerAppointment: "Заметки о контакте",
              appointmentsModal: {
                title: "Заметки о контакте",
                textarea: "Заметка",
                placeholder: "Введите информацию, которую хотите записать"
              }
            },
            confirmationModal: {
              buttons: {
                confirm: "ОК",
                cancel: "Отмена"
              }
            },
            messageOptionsMenu: {
              delete: "Удалить",
              reply: "Ответить",
              copy: "Копировать",
              copied: "Текст скопирован",
              edit: "Редактировать",
              history: "История",
              forward: "Переслать",
              forwardbutton: "Выберите пользователя для пересылки",
              reactions: "Реакции",
              removeReactions: "Удалить реакцию",
              confirmationModal: {
                title: "Удалить сообщение?",
                message: "Это действие нельзя отменить."
              }
            },
            backendErrors: {
              ERR_META_MEDIA_UNSUPPORTED: "Отправка файлов пока не поддерживается в этом канале.",
              ERR_MEDIA_TOO_LARGE: "Файл слишком большой для отправки в этом канале (макс. 20 МБ).",
              ERR_META_SEND_FAILED: "Не удалось отправить сообщение в этом канале — попробуйте ещё раз.",
              ERR_META_TOKEN_INVALID: "Подключение канала истекло — переподключите его в настройках.",
              ERR_FACEBOOK_WINDOW_EXPIRED: "24-часовое окно ответа закрыто; клиент должен написать первым.",
              ERR_META_COMMENT_REPLY_NOT_PERMITTED: "Facebook не разрешает личный ответ на комментарий к публикации (нужна проверка приложения). Чтобы ответить, клиент должен написать вам в Messenger.",
              ERR_EDIT_NOT_SUPPORTED_FOR_CHANNEL: "Редактирование сообщений не поддерживается в этом канале.",
              ERR_DELETE_NOT_SUPPORTED_FOR_CHANNEL: "Удаление сообщений не поддерживается в этом канале.",
              ERR_CANNOT_FORWARD_TO_OMNICHANNEL: "Пересылка в этот канал не поддерживается.",
              ERR_CANNOT_FORWARD_FROM_OMNICHANNEL: "Пересылка из этого канала не поддерживается.",
              ERR_MESSAGE_BODY_REQUIRED: "Требуется текст сообщения.",
              ERR_NO_OTHER_WHATSAPP: "Должен быть хотя бы один WhatsApp по умолчанию.",
              ERR_NO_DEF_WAPP_FOUND: "WhatsApp по умолчанию не найден. Проверьте страницу соединений.",
              ERR_WAPP_NOT_INITIALIZED: "Эта сессия WhatsApp не инициализирована. Проверьте страницу соединений.",
              ERR_WAPP_CHECK_CONTACT: "Не удалось проверить контакт WhatsApp. Проверьте страницу соединений.",
              ERR_WAPP_INVALID_CONTACT: "Это недействительный номер WhatsApp.",
              ERR_WAPP_DOWNLOAD_MEDIA: "Не удалось загрузить медиа из WhatsApp. Проверьте страницу соединений.",
              ERR_INVALID_CREDENTIALS: "Ошибка аутентификации. Попробуйте снова.",
              ERR_SENDING_WAPP_MSG: "Ошибка отправки сообщения WhatsApp. Проверьте страницу соединений.",
              ERR_DELETE_WAPP_MSG: "Не удалось удалить сообщение WhatsApp.",
              ERR_OTHER_OPEN_TICKET: "Уже есть открытый тикет для этого контакта.",
              ERR_SESSION_EXPIRED: "Сессия истекла. Пожалуйста, войдите.",
              ERR_USER_CREATION_DISABLED: "Создание пользователей отключено администратором.",
              ERR_NO_PERMISSION: "У вас нет разрешения на доступ к этому ресурсу.",
              ERR_DUPLICATED_CONTACT: "Контакт с этим номером уже существует.",
              ERR_NO_SETTING_FOUND: "Настройка с этим ID не найдена.",
              ERR_NO_CONTACT_FOUND: "Контакт с этим ID не найден.",
              ERR_NO_TICKET_FOUND: "Тикет с этим ID не найден.",
              ERR_NO_USER_FOUND: "Пользователь с этим ID не найден.",
              ERR_NO_WAPP_FOUND: "WhatsApp с этим ID не найден.",
              ERR_CREATING_MESSAGE: "Ошибка создания сообщения в базе данных.",
              ERR_CREATING_TICKET: "Ошибка создания тикета в базе данных.",
              ERR_FETCH_WAPP_MSG: "Ошибка получения сообщения из WhatsApp, возможно оно слишком старое.",
              ERR_QUEUE_COLOR_ALREADY_EXISTS: "Этот цвет уже используется, выберите другой.",
              ERR_WAPP_GREETING_REQUIRED: "Приветственное сообщение обязательно, когда есть более одной очереди.",
              ERR_VOICE_DIAL_FAILED: "Не удалось выполнить звонок. Проверьте, что звонки в эту страну разрешены для аккаунта.",
              ERR_EDITING_WAPP_MSG: "Не удалось отредактировать сообщение WhatsApp."
            },
            appBar: {
              i18n: {
                language: "Русский",
                language_short: "RU"
              },
              greetings: {
                one: "Здравствуйте",
                two: "Добро пожаловать в"
              },
              user: {
                profile: "Профиль",
                darkmode: "Тёмная тема",
                lightmode: "Светлая тема",
                language: "Выберите язык",
                logout: "Выйти"
              }
            },
            messagesAPI: {
              title: "API",
              textMessage: {
                number: "Номер",
                body: "Сообщение",
                token: "Зарегистрированный токен"
              },
              mediaMessage: {
                number: "Номер",
                body: "Имя файла",
                media: "Файл",
                token: "Зарегистрированный токен"
              }
            },
            notifications: {
              noTickets: "Нет уведомлений."
            },
            toDoList: {
              confirmDelete: "Удалить \"{{title}}\"? Нельзя отменить.",
              title: "Управление задачами",
              tasksCompleted: "задач выполнено",
              reminder: "Напоминание",
              dueIn: "через",
              hours: "часов",
              reminderEnabled: "Напоминание включено",
              stats: {
                total: "Всего",
                active: "Активных",
                completed: "Выполнено",
                overdue: "Просрочено"
              },
              tabs: {
                all: "Все",
                active: "Активные",
                completed: "Выполненные",
                overdue: "Просроченные"
              },
              filters: {
                allPriorities: "Все приоритеты",
                allTypes: "Все типы"
              },
              sort: {
                newest: "Сначала новые",
                priority: "По приоритету",
                dueDate: "По дате",
                title: "По названию"
              },
              priority: {
                high: "Высокий",
                medium: "Средний",
                low: "Низкий",
                urgent: "Срочно"
              },
              dates: {
                today: "Сегодня",
                tomorrow: "Завтра"
              },
              form: {
                label: "Создать новую задачу",
                placeholder: "Введите задачу",
                title: "Название",
                description: "Описание",
                priority: "Приоритет",
                dueDate: "Срок",
                reminderOn: "🔔 Напоминание ВКЛ (за 24ч)",
                reminderOff: "🔕 Включить напоминание",
                category: "Категория",
                noCategory: "Без категории",
                reminderDate: "Дата напоминания",
                visibility: "Видимость",
                assignTo: "Назначить",
                myself: "Мне",
                team: "Команда",
                selectTeam: "Выбрать команду",
                queue: "Очередь",
                selectQueue: "Выбрать очередь",
                shareWith: "Поделиться с",
                selectUsers: "Выбрать пользователей"
              },
              table: {
                task: "Задача",
                date: "Дата создания",
                actions: "Действия"
              },
              buttons: {
                add: "Добавить задачу",
                save: "Сохранить",
                cancel: "Отмена",
                newTask: "Новая задача",
                createFirst: "Создайте первую задачу"
              },
              dialog: {
                newTask: "Новая задача",
                editTask: "Редактировать задачу"
              },
              actions: {
                markComplete: "Отметить как выполненную",
                markIncomplete: "Отметить как невыполненную",
                edit: "Редактировать",
                delete: "Удалить",
                refresh: "Обновить",
                complete: "Выполнить",
                reopen: "Открыть заново"
              },
              messages: {
                created: "Задача успешно создана",
                updated: "Задача успешно обновлена",
                deleted: "Задача удалена",
                completed: "Выполнено!"
              },
              errors: {
                titleRequired: "Требуется название задачи"
              },
              empty: {
                noTasks: "Задач пока нет. Создайте первую!",
                noCompleted: "Нет выполненных задач",
                noOverdue: "Отлично! Нет просроченных задач"
              },
              status: {
                pending: "Ожидает",
                in_progress: "В работе",
                completed: "Выполнено",
                cancelled: "Отменено"
              },
              visibility: {
                personal: "Личная",
                personalDesc: "Только вы видите",
                shared: "Общая",
                sharedDesc: "Поделиться с выбранными",
                team: "Команда",
                teamDesc: "Видят все в команде",
                queue: "Очередь",
                queueDesc: "Видят все в очереди"
              },
              noAssignee: "Не назначено",
              notifications: {
                newTaskAssigned: "Вам назначена новая задача"
              },
              comments: {
                title: "Комментарии",
                noComments: "Комментариев пока нет",
                placeholder: "Написать комментарий...",
                added: "Комментарий добавлен",
                deleted: "Комментарий удалён",
                addFailed: "Не удалось добавить комментарий",
                deleteFailed: "Не удалось удалить комментарий",
                delete: "Удалить комментарий",
                unknownUser: "Неизвестный пользователь"
              }
            },
            kanban: {
              title: "Канбан",
              searchPlaceholder: "Поиск",
              subMenus: {
                list: "Панель",
                tags: "Дорожки"
              }
            },
            tagsKanban: {
              title: "Дорожки",
              laneDefault: "Открыто",
              confirmationModal: {
                deleteTitle: "Вы уверены, что хотите удалить эту дорожку?",
                deleteMessage: "Это действие нельзя отменить."
              },
              table: {
                name: "Название",
                color: "Цвет",
                tickets: "Тикеты",
                actions: "Действия"
              },
              buttons: {
                add: "Новая дорожка"
              },
              toasts: {
                deleted: "Дорожка успешно удалена."
              }
            },
            contactLists: {
              title: "Списки контактов",
              table: {
                name: "Название",
                contacts: "Контакты",
                actions: "Действия"
              },
              buttons: {
                add: "Новый список"
              },
              dialog: {
                name: "Название",
                company: "Компания",
                okEdit: "Редактировать",
                okAdd: "Добавить",
                add: "Добавить",
                edit: "Редактировать",
                cancel: "Отмена"
              },
              confirmationModal: {
                deleteTitle: "Удалить",
                deleteMessage: "Это действие нельзя отменить."
              },
              toasts: {
                deleted: "Запись удалена",
                created: "Запись создана"
              }
            },
            contactListItems: {
              title: "Контакты",
              searchPlaceholder: "Поиск",
              buttons: {
                add: "Новый",
                lists: "Списки",
                import: "Импорт"
              },
              dialog: {
                name: "Имя",
                number: "Номер",
                whatsapp: "WhatsApp",
                email: "Email",
                okEdit: "Редактировать",
                okAdd: "Добавить",
                add: "Добавить",
                edit: "Редактировать",
                cancel: "Отмена"
              },
              table: {
                name: "Имя",
                number: "Номер",
                whatsapp: "WhatsApp",
                email: "Email",
                actions: "Действия"
              },
              confirmationModal: {
                deleteTitle: "Удалить",
                deleteMessage: "Это действие нельзя отменить.",
                importMessage: "Вы хотите импортировать контакты из этой таблицы? ",
                importTitlte: "Импорт"
              },
              toasts: {
                deleted: "Запись удалена"
              }
            },
            campaigns: {
              title: "Кампании WhatsApp",
              searchPlaceholder: "Поиск кампаний...",
              buttons: {
                add: "Новая кампания",
                addRecipients: "Добавить получателей",
                send: "Отправить кампанию",
                edit: "Редактировать",
                delete: "Удалить",
                viewStats: "Статистика",
                refresh: "Обновить",
                contactLists: "Списки контактов",
                pause: "Пауза",
                resume: "Продолжить",
                stop: "Остановить",
                restart: "Перезапустить"
              },
              table: {
                name: "Название",
                type: "Тип",
                template: "Шаблон",
                whatsapp: "Соединение",
                contactList: "Список контактов",
                status: "Статус",
                recipients: "Получатели",
                progress: "Прогресс",
                scheduledAt: "Запланировано",
                completedAt: "Завершено",
                createdAt: "Создано",
                confirmation: "Подтверждение",
                actions: "Действия",
                sentAt: "Отправлено"
              },
              status: {
                draft: "Черновик",
                scheduled: "Запланировано",
                sending: "Отправка",
                paused: "Приостановлено",
                completed: "Завершено",
                cancelled: "Отменено",
                failed: "Ошибка"
              },
              types: {
                marketing: "Маркетинг",
                service_update: "Обновление сервиса"
              },
              dialog: {
                new: "Создать кампанию",
                update: "Редактировать кампанию",
                readonly: "Только чтение",
                form: {
                  name: "Название кампании",
                  type: "Тип",
                  template: "Шаблон",
                  language: "Язык",
                  whatsapp: "Соединение WhatsApp",
                  scheduledAt: "Запланировать отправку (опционально)",
                  scheduledAtHint: "Оставьте пустым для ручной отправки",
                  message1: "Сообщение 1",
                  message2: "Сообщение 2",
                  message3: "Сообщение 3",
                  message4: "Сообщение 4",
                  message5: "Сообщение 5",
                  confirmationMessage1: "Подтверждение 1",
                  confirmationMessage2: "Подтверждение 2",
                  confirmationMessage3: "Подтверждение 3",
                  confirmationMessage4: "Подтверждение 4",
                  confirmationMessage5: "Подтверждение 5",
                  messagePlaceholder: "Содержание сообщения",
                  status: "Статус",
                  confirmation: "Подтверждение",
                  contactList: "Список контактов"
                },
                buttons: {
                  add: "Создать",
                  edit: "Сохранить",
                  okadd: "Ок",
                  cancel: "Отмена",
                  restart: "Перезапустить рассылки",
                  close: "Закрыть",
                  attach: "Прикрепить файл",
                  import: "Импорт"
                }
              },
              recipients: {
                title: "Добавить получателей",
                tabs: {
                  csv: "Загрузка CSV",
                  manual: "Ручной ввод",
                  contacts: "Из контактов"
                },
                csv: {
                  description: "Загрузите CSV файл с колонками: phone, name (опционально), var1, var2, var3 (для переменных шаблона)",
                  upload: "Нажмите для загрузки CSV файла",
                  preview: "Предпросмотр",
                  rows: "строк",
                  moreRows: "и ещё {{count}} строк",
                  variables: "Переменные"
                },
                manual: {
                  description: "Введите номера телефонов (по одному на строку или через запятую). Номера должны быть в международном формате (например: 972501234567).",
                  placeholder: "972501234567\n972502345678\n972503456789",
                  numbersEntered: "введено {{count}} номеров"
                },
                contacts: {
                  search: "Поиск контактов...",
                  selectAll: "Выбрать все",
                  selected: "выбрано {{count}}",
                  noContacts: "Контакты не найдены"
                },
                importResult: {
                  title: "Импорт завершён:",
                  imported: "Импортировано",
                  duplicates: "Дубликаты",
                  invalid: "Неверные",
                  matched: "Сопоставлено контактов"
                }
              },
              details: {
                stats: {
                  total: "Всего",
                  pending: "Ожидают",
                  sent: "Отправлено",
                  delivered: "Доставлено",
                  read: "Прочитано",
                  failed: "Ошибки"
                },
                info: {
                  template: "Шаблон",
                  language: "Язык",
                  whatsapp: "WhatsApp",
                  created: "Создано"
                },
                tabs: {
                  all: "Все получатели",
                  failed: "С ошибками"
                },
                noRecipients: "Получателей пока нет. Импортируйте из CSV для добавления.",
                error: "Ошибка"
              },
              confirmationModal: {
                deleteTitle: "Удалить кампанию",
                deleteMessage: "Вы уверены, что хотите удалить \"{{name}}\"? Это действие нельзя отменить.",
                sendTitle: "Отправить кампанию",
                sendMessage: "Отправить кампанию \"{{name}}\" {{count}} получателям?"
              },
              toasts: {
                success: "Операция успешно завершена",
                created: "Кампания успешно создана",
                updated: "Кампания успешно обновлена",
                cancel: "Кампания отменена",
                restart: "Кампания перезапущена",
                deleted: "Кампания успешно удалена",
                sending: "Отправка кампании начата!",
                importSuccess: "Импортировано {{count}} получателей",
                noRecipients: "Добавьте получателей перед отправкой",
                fillRequired: "Заполните все обязательные поля",
                selectRecipients: "Выберите хотя бы одного получателя",
                enterNumbers: "Введите хотя бы один номер телефона",
                noData: "Нет данных для импорта"
              },
              empty: {
                title: "Кампаний пока нет",
                description: "Создайте свою первую кампанию!"
              }
            },
            followUp: {
              tooltip: "Умное напоминание",
              dialog: {
                title: "Умное напоминание",
                description: "Автоматически отправить шаблон напоминания, если клиент не ответит.",
                status: "Напоминание активно",
                selectTemplate: "Выберите шаблон",
                activeTemplate: "Активный шаблон",
                delay: "Отправить через",
                minutes: "минут",
                hour: "час",
                hours: "часов",
                testMode: "Тестовый режим",
                willSendAfter5min: "Будет отправлено автоматически через 5 минут после вашего последнего сообщения (тестовый режим).",
                willSendAfter1h: "Будет отправлено автоматически через 1 час после вашего последнего сообщения, если клиент не ответит.",
                willSendAfter24h: "Будет отправлено автоматически через 24ч после вашего последнего сообщения, если клиент не ответит.",
                close: "Закрыть",
                customerName: "Имя клиента",
                customerNameHint: "Это имя будет использовано в шаблоне ({{1}}). При необходимости можно изменить.",
                fillParameters: "Заполните переменные шаблона:",
                parameter: "Параметр",
                noParameters: "Этот шаблон не имеет динамических параметров."
              },
              success: {
                enabled: "Напоминание включено!",
                disabled: "Напоминание отключено."
              },
              errors: {
                selectTemplate: "Сначала выберите шаблон."
              }
            },
            campaignsConfig: {
              title: "Настройки кампаний"
            },
            queueSelect: {
              inputLabel: "Очереди"
            },
            queueOptions: {
              forward: "Отправить в очередь"
            },
            contactWhatsappUsername: {
              label: "Имя пользователя WhatsApp (@username)",
              placeholder: "john.doe",
              helper: "Необязательно — уникальный WhatsApp-логин (3-35 символов, строчные буквы / цифры / точки / подчёркивания)",
              validation: {
                tooShort: "Имя пользователя должно содержать минимум 3 символа",
                tooLong: "Имя пользователя может содержать максимум 35 символов",
                invalidChars: "Имя пользователя может содержать только строчные буквы, цифры, точки и подчёркивания",
                noWww: "Имя пользователя не может начинаться с www.",
                noDomain: "Имя пользователя не может заканчиваться доменным суффиксом (.com, .net…)"
              }
            },
            time: {
              hourAbbr: "ч",
              minuteAbbr: "м",
              dayAbbr: "д"
            },
            messagesList: {
              ack: {
                failed: "Не доставлено — возможно Meta заблокировала сообщение или номер недействителен",
                pending: "Ожидание отправки…",
                sent: "Отправлено на сервер WhatsApp",
                delivered: "Доставлено на телефон получателя",
                read: "Прочитано получателем"
              },
              edited: "Изменено",
              quotedImage: "Изображение",
              quotedVideo: "Видео",
              quotedAudio: "Голосовое сообщение",
              quotedDocument: "Документ",
              quotedSticker: "Стикер",
              replyToYou: "Вы",
              header: {
                assignedTo: "Назначено:",
                today: "Сегодня",
                yesterday: "Вчера",
                selected: "выбрано",
                buttons: {
                  return: "Вернуть",
                  resolve: "Решить",
                  reopen: "Открыть заново",
                  accept: "Принять",
                  disableAI: "Выкл. AI",
                  enableAI: "Вкл. AI",
                  markAsUnread: "Отметить как непрочитанное"
                }
              },
              invalidVCard: "Неверные данные контакта",
              messageContact: "Написать",
              addToContacts: "Добавить в контакты",
              contactAdded: "Контакт успешно добавлен!",
              contactAddError: "Ошибка добавления контакта",
              contactExists: "Этот контакт уже есть в вашем списке контактов.",
              noPhoneNumber: "Номер телефона недоступен"
            },
            contactDrawerSections: {
              noLinkedChannels: "Нет привязанных каналов",
              openChat: "Открыть чат",
              disconnectChannel: "Отвязать канал",
              channelIdPlaceholder: "ID канала (телефон / PSID / email)",
              cancel: "Отмена",
              connect: "Привязать",
              connectNewChannel: "Привязать новый канал",
              statusOpen: "Открыт",
              statusPending: "Ожидает",
              statusClosed: "Закрыт",
              noTicketHistory: "Нет истории диалогов",
              totalTickets: "Всего диалогов",
              openTickets: "Открытые",
              channels: "Каналы",
              customerSince: "Клиент с",
              communicationChannels: "Каналы связи",
              customerJourney: "Путь клиента"
            },
            voiceTimeline: {
              statusCompleted: "Завершён",
              statusNoAnswer: "Без ответа",
              statusBusy: "Занято",
              statusFailed: "Не удался",
              statusActive: "Идёт разговор",
              statusRinging: "Звонит",
              statusQueued: "Набор номера",
              outcomeSale: "Продажа",
              outcomeFollowUp: "Повторный контакт",
              outcomeSupport: "Поддержка",
              outcomePayment: "Оплата",
              outcomeComplaint: "Жалоба",
              outcomeNoAnswer: "Без ответа",
              sentimentPositive: "Позитивный",
              sentimentNeutral: "Нейтральный",
              sentimentNegative: "Негативный",
              sentimentUrgent: "Срочный",
              intentSales: "Продажа",
              intentSupport: "Поддержка",
              intentPayment: "Оплата",
              intentComplaint: "Жалоба",
              intentInformation: "Информация",
              minShort: "мин",
              secShort: "сек",
              seconds: "сек.",
              outgoing: "Исходящий звонок",
              incoming: "Входящий звонок",
              recorded: "Записан",
              recording: "Запись",
              listenRecording: "Прослушать запись",
              aiAnalysis: "AI-анализ",
              transcript: "Расшифровка",
              transcribing: "Расшифровка…",
              createTranscript: "Создать расшифровку",
              analyzing: "Анализ…",
              analyzeCall: "Проанализировать звонок",
              noRecording: "Для этого звонка нет записи.",
              transcriptNotFound: "Расшифровка не найдена (звонок слишком короткий или без речи).",
              quickCharge: "Быстрая оплата",
              followUpAction: "Контроль и действие"
            },
            channelFilter: {
              showAll: "Показать все",
              channelLabel: "Канал:",
              label: "Каналы",
              all: "Показать все",
              whatsapp: "WhatsApp",
              facebook: "Мессенджер",
              instagram: "Instagram",
              email: "Эл. почта",
              telegram: "Telegram",
              businessApi: "WhatsApp Business"
            },
            messageInput: {
              noTemplates: "Шаблоны недоступны",
              syncTemplates: "Синхронизировать шаблоны из настроек",
              chooseEmoji: "Выбрать эмодзи",
              emojiPicker: {
                search: "Поиск",
                clear: "Очистить",
                notfound: "Эмодзи не найдены",
                categories: {
                  search: "Результаты поиска",
                  recent: "Часто используемые",
                  smileys: "Смайлы",
                  people: "Люди",
                  nature: "Природа",
                  foods: "Еда",
                  activity: "Активность",
                  places: "Места",
                  objects: "Объекты",
                  symbols: "Символы",
                  flags: "Флаги"
                }
              }
            },
            contactNotes: {
              toasts: {
                added: "Заметка добавлена",
                deleted: "Заметка удалена"
              },
              confirm: {
                title: "Удалить заметку",
                message: "Вы действительно хотите удалить эту заметку?"
              }
            },
            messageHistoryModal: {
              close: "Закрыть",
              title: "История редактирования сообщения"
            },
            presence: {
              unavailable: "Недоступен",
              available: "Доступен",
              composing: "Печатает...",
              recording: "Записывает...",
              paused: "Пауза"
            },
            privacyModal: {
              title: "Редактировать конфиденциальность WhatsApp",
              buttons: {
                cancel: "Отмена",
                okEdit: "Сохранить"
              },
              form: {
                menu: {
                  all: "Все",
                  none: "Никто",
                  contacts: "Мои контакты",
                  contact_blacklist: "Выбранные контакты",
                  match_last_seen: "Совпадение последнего посещения",
                  known: "Известные",
                  disable: "Отключено",
                  hrs24: "24 часа",
                  dias7: "7 дней",
                  dias90: "90 дней"
                },
                readreceipts: "Обновить конфиденциальность уведомлений о прочтении",
                profile: "Обновить конфиденциальность фото профиля",
                status: "Обновить конфиденциальность сообщений",
                online: "Обновить конфиденциальность онлайн-статуса",
                last: "Обновить конфиденциальность последнего посещения",
                groupadd: "Обновить конфиденциальность добавления в группы",
                calladd: "Обновить конфиденциальность добавления в звонки",
                disappearing: "Обновить режим исчезающих сообщений по умолчанию"
              }
            },
            contactProfile: {
              title: "Аналитика клиента",
              emptyState: "Профиль будет создан автоматически из разговора",
              confidence: "Уверенность",
              updated: "Обновлено",
              profileNotBuilt: "Профиль еще не создан",
              sections: {
                personal: "Личные данные",
                travel: "Интересы путешествий",
                family: "Семья",
                preferences: "Предпочтения"
              },
              labels: {
                name: "Имя",
                language: "Язык",
                country: "Страна",
                destinations: "Направления",
                months: "Месяцы",
                duration: "Продолжительность",
                budget: "Бюджет",
                accommodation: "Размещение",
                adults: "Взрослые",
                children: "Дети",
                ages: "Возраст",
                requirements: "Требования",
                interest: "Интерес",
                style: "Стиль",
                activities: "Активности"
              },
              fields: {
                customerName: "Имя клиента",
                destination: "Направление",
                travelDates: "Даты/месяцы поездки",
                adultsCount: "Количество взрослых",
                childrenAges: "Возраст детей"
              },
              readyToBook: {
                title: "Готовность к бронированию",
                statusReady: "Готово",
                statusAlmost: "Почти",
                statusMissing: "Нет данных",
                noProfile: "Нет профиля",
                noProfileDesc: "Для создания сводки бронирования необходим профиль клиента. Профиль создается автоматически, когда ИИ извлекает информацию из разговора.",
                missingInfo: "Недостающая информация",
                generating: "Генерация...",
                generateSummary: "Создать сводку бронирования",
                tryGenerate: "Попробовать создать",
                copyToClipboard: "Копировать в буфер",
                statusReadyFull: "Готово к бронированию",
                statusAlmostFull: "Почти готово",
                statusMoreInfo: "Нужна дополнительная информация"
              },
              toasts: {
                ticketRequired: "Требуется ID тикета для создания сводки",
                generateFailed: "Не удалось создать сводку бронирования",
                copied: "Сводка скопирована в буфер"
              }
            },
            settings: {
              customDomain: {
                tab: "Свой домен",
                title: "Свой домен",
                subtitle: "Разместите CRM на собственном адресе, например crm.yourbrand.com. Добавьте домен, направьте DNS-записи на нас, и мы автоматически выпустим HTTPS-сертификат.",
                notEntitled: "Свои домены доступны на более высоком тарифе. Свяжитесь с нами, чтобы разместить CRM на собственном адресе.",
                step1: "1. Введите ваш домен",
                domainLabel: "Домен",
                add: "Добавить домен",
                step2: "2. Добавьте эти DNS-записи у вашего провайдера",
                dnsPropagation: "Изменения DNS могут распространяться до часа. Когда записи станут активны, нажмите «Проверить».",
                dnsNotFound: "Записи пока не обнаружены — проверьте их и попробуйте снова.",
                check: "Проверить DNS",
                remove: "Удалить",
                activePrefix: "Ваша CRM доступна по адресу",
                open: "Открыть",
                statusActive: "Активен",
                statusDisabled: "Не настроен",
                statusSsl: "Выпуск сертификата",
                statusDns: "Ожидание DNS",
                copy: "Копировать значение",
                copied: "Скопировано",
                reserved: "Домен сохранён — добавьте DNS-записи ниже.",
                removeConfirm: "Удалить этот свой домен?",
                removed: "Свой домен удалён.",
              },
              group: {
                general: "Общие",
                generalDesc: "Основные настройки бота",
                timeouts: "Таймауты",
                officeHours: "Рабочие часы",
                groups: "Группы",
                groupsDesc: "Настройки групп и уведомлений",
                confidenciality: "Конфиденциальность",
                api: "API",
                apiDesc: "Интеграция и доступ",
                serveradmin: "Администрирование сервера",
                archive: "Архив"
              },
              success: "Настройки успешно сохранены.",
              updateSuccess: "Настройки сохранены.",
              pushNotifications: {
                title: "Push-уведомления на телефон",
                subtitle: "Управление push-уведомлениями в мобильном приложении",
                toggle: {
                  title: "Push-уведомления",
                  helper: "Эта настройка влияет только на мобильное приложение."
                },
                scope: {
                  title: "Какие сообщения вызывают уведомление",
                  all: "Все входящие сообщения",
                  byTag: "Только чаты с выбранными тегами"
                },
                tags: {
                  title: "Выбранные теги",
                  helper: "Уведомление отправляется только для чатов с одним из выбранных тегов.",
                  placeholder: "Выберите теги",
                  empty: "Нет доступных тегов — сначала создайте теги"
                }
              },
              apiToken: "API Token",
              apiTokenEmpty: "Токен ещё не сгенерирован",
              copy: "Копировать",
              generateToken: "Сгенерировать токен",
              tokenCopied: "Токен скопирован в буфер обмена",
              title: "Настройки",
              settings: {
                userCreation: {
                  name: "Создание пользователя",
                  options: {
                    enabled: "Включено",
                    disabled: "Отключено"
                  }
                }
              },
              validations: {
                title: "проверки",
                options: {
                  enabled: "включено",
                  disabled: "отключено"
                }
              },
              OfficeManagement: {
                title: "Управление офисом",
                options: {
                  disabled: "отключено",
                  ManagementByDepartment: "Управление по отделам",
                  ManagementByCompany: "Управление по компаниям"
                }
              },
              outOfHoursAction: {
                title: "Действие вне рабочих часов",
                options: {
                  pending: "Оставить как ожидающий",
                  closed: "Закрыть тикет"
                }
              },
              IgnoreGroupMessages: {
                title: "Игнорировать групповые сообщения",
                options: {
                  enabled: "включено",
                  disabled: "отключено"
                }
              },
              soundGroupNotifications: {
                title: "Звук для групповых уведомлений",
                options: {
                  enabled: "включено",
                  disabled: "отключено"
                }
              },
              groupsTab: {
                title: "Вкладка групп",
                options: {
                  enabled: "включено",
                  disabled: "отключено"
                }
              },
              VoiceAndVideoCalls: {
                title: "Голосовые и видеозвонки",
                options: {
                  enabled: "Игнорировать",
                  disabled: "отчёт о недоступности"
                }
              },
              AutomaticChatbotOutput: {
                title: "Автоматический выход из чат-бота",
                options: {
                  enabled: "включено",
                  disabled: "отключено"
                }
              },
              chatbotResetDays: {
                title: "Авто сброс бота",
                helper: "Дней неактивности до перезапуска бота",
                options: {
                  never: "Никогда",
                  day: "день",
                  days: "дней"
                }
              },
              systemLanguage: {
                title: "Язык системы",
                helper: "По браузеру. Изменение перезагрузит страницу.",
                updateSuccess: "Язык обновлен. Перезагрузка..."
              },
              QuickMessages: {
                title: "Быстрые сообщения",
                options: {
                  enabled: "По компании",
                  disabled: "По пользователю"
                }
              },
              AllowRegistration: {
                title: "Разрешить регистрацию",
                options: {
                  enabled: "включено",
                  disabled: "отключено"
                }
              },
              FileDownloadLimit: {
                title: "Лимит загрузки файлов (МБ)"
              },
              keepQueueAndUser: {
                title: "Сохранять очередь и пользователя при закрытии тикета",
                options: {
                  enabled: "Включено",
                  disabled: "Отключено"
                }
              },
              WelcomeGreeting: {
                greetings: "Здравствуйте",
                welcome: "Добро пожаловать в",
                expirationTime: "Активно до"
              },
              Options: {
                title: "Опции"
              },
              GPT: {
                title: "GPT AI"
              },
              Templates: {
                title: "Шаблоны"
              },
              Archive: {
                title: "Архив"
              },
              Companies: {
                title: "Компании"
              },
              schedules: {
                title: "расписания"
              },
              Plans: {
                title: "Планы"
              },
              Help: {
                title: "Помощь"
              },
              Whitelabel: {
                title: "Белая метка"
              },
              Subscriptions: {
                title: "Подписки"
              },
              Payments: {
                title: "Платежи"
              },
              PaymentGateways: {
                title: "Платёжные шлюзы"
              },
              sections: {
                general: "Общее",
                billing: "Платежи",
                admin: "Администрирование"
              },
              companies: {
                subtitle: "{{active}} активных · {{expiring}} истекают через 7 дней",
                add: "Добавить компанию",
                searchPlaceholder: "Поиск по имени, email или телефону...",
                statusLabel: "Статус",
                allStatuses: "Все статусы",
                activeOnly: "Только активные",
                blockedOnly: "Только заблокированные",
                planLabel: "План",
                allPlans: "Все планы",
                statusActive: "Активная",
                statusBlocked: "Заблокирована",
                col: {
                  company: "Компания",
                  contact: "Контакт",
                  plan: "План",
                  status: "Статус",
                  created: "Создана",
                  expiration: "Истекает",
                  actions: "Действия"
                }
              },
              plans: {
                subtitle: "{{publicCount}} публичных · {{privateCount}} приватных",
                add: "Добавить план",
                searchPlaceholder: "Поиск по названию плана...",
                visibilityLabel: "Видимость",
                allPlans: "Все планы",
                publicOnly: "Только публичные",
                privateOnly: "Только приватные",
                public: "Публичный",
                private: "Приватный",
                month: "месяц",
                customPricing: "Цена по запросу",
                users: "пользователей",
                connections: "WhatsApp подключений",
                queues: "очередей",
                editTooltip: "Редактировать план",
                deleteTooltip: "Удалить план"
              },
              whitelabel: {
                identity: {
                  title: "Идентичность",
                  desc: "Название бренда, отображаемое в системе"
                },
                colors: {
                  title: "Цвета бренда",
                  desc: "Основной цвет для кнопок, табов и акцентов"
                },
                assets: {
                  title: "Ресурсы бренда",
                  desc: "Логотипы и favicon для светлой/тёмной темы"
                },
                appName: "Название системы",
                primaryLight: "Основной — Светлый режим",
                primaryDark: "Основной — Тёмный режим",
                logoLight: "Светлый логотип",
                logoDark: "Тёмный логотип",
                favicon: "Favicon",
                upload: "Загрузить"
              }
            },
            godeal: {
              support: {
                title: "Поддержать проект godeal",
                mercadopagotitle: "Кредитная карта",
                recurringbrl: "Регулярные пожертвования в BRL",
                paypaltitle: "Кредитная карта",
                international: "Пожертвования в USD"
              }
            },
            scheduleMessageModal: {
              title: "Запланировать сообщение",
              messagePreview: "Сообщение для отправки:",
              noMessage: "Сообщение не введено",
              quickSelect: "Быстрый выбор:",
              minutes: "мин",
              hour: "час",
              hours: "часов",
              tomorrow: "Завтра",
              dateTime: "Дата и время",
              sendTo: "Будет отправлено:",
              cancel: "Отмена",
              schedule: "Запланировать",
              scheduling: "Планирование...",
              success: "Сообщение успешно запланировано!",
              errors: {
                noMessage: "Сначала введите сообщение",
                noDate: "Выберите дату и время",
                pastDate: "Выберите дату в будущем"
              }
            },
            mergeBackupModal: {
              title: "Импорт истории чата",
              selectBackup: "Выберите резервную копию для импорта",
              selectBackupHint: "Выберите файл резервной копии, соответствующий номеру этого контакта:",
              noBackups: "Подходящие резервные копии не найдены",
              noBackupsHint: "Загрузите резервные копии с номерами телефонов в имени файла для включения импорта",
              phone: "Телефон",
              merge: "Импортировать историю",
              merging: "Импорт...",
              close: "Закрыть",
              success: "История чата успешно импортирована!",
              mergeComplete: "Импорт завершён",
              messagesCreated: "Сообщений импортировано",
              messagesSkipped: "Дубликатов пропущено"
            },
            fileModal: {
              title: {
                add: "Добавить запись каталога",
                edit: "Редактировать запись каталога"
              },
              form: {
                name: "Название элемента",
                message: "Описание элемента",
                fileOptions: "Вложения",
                extraName: "Дополнительные сведения"
              },
              buttons: {
                okAdd: "Сохранить",
                okEdit: "Обновить",
                cancel: "Отмена",
                fileOptions: "Добавить вложение"
              },
              success: "Запись каталога успешно сохранена."
            },
            uploads: {
              titles: {
                titleUploadMsgDragDrop: "ПЕРЕТАЩИТЕ ФАЙЛЫ В ПОЛЕ НИЖЕ",
                titleFileList: "Список файлов"
              }
            },
            ticketsManager: {
              buttons: {
                newTicket: "Новый"
              }
            },
            transferTicketModal: {
              title: "Передать тикет",
              fieldLabel: "Введите для поиска пользователей",
              fieldQueueLabel: "Передать в очередь",
              fieldQueuePlaceholder: "Выберите очередь",
              noOptions: "Пользователь с таким именем не найден",
              buttons: {
                ok: "Передать",
                cancel: "Отмена"
              }
            },
            forwardMessageModal: {
              dialog: {
                title: "Переслать сообщение:",
                button: "Отправить",
                sending: "Отправка",
                error: "Выберите сообщения для пересылки"
              }
            },
            newTicketModal: {
              title: "Создать тикет",
              fieldLabel: "Введите для поиска контакта",
              add: "Добавить",
              buttons: {
                ok: "Сохранить",
                cancel: "Отмена"
              }
            },
            helps: {
              title: "Центр помощи"
            },
            teams: {
              title: "Управление командами",
              stats: {
                totalTeams: "Всего команд",
                totalMembers: "Всего участников"
              },
              empty: {
                title: "Команд пока нет",
                description: "Создайте первую команду для организации агентов"
              },
              table: {
                name: "Название команды",
                description: "Описание",
                members: "Участники",
                actions: "Действия"
              },
              buttons: {
                new: "Новая команда",
                createFirst: "Создать первую команду",
                cancel: "Отмена",
                create: "Создать",
                save: "Сохранить"
              },
              membersCount: "участников",
              noMembers: "Нет участников",
              dialog: {
                newTitle: "Новая команда",
                editTitle: "Редактировать команду"
              },
              form: {
                name: "Название команды",
                description: "Описание",
                members: "Участники команды",
                searchUsers: "Поиск пользователей...",
                noUsersFound: "Пользователи не найдены",
                tryDifferentSearch: "Попробуйте другой поиск"
              },
              actions: {
                edit: "Редактировать",
                delete: "Удалить"
              },
              deleteConfirm: {
                title: "Удалить команду",
                message: "Вы уверены, что хотите удалить эту команду?"
              },
              messages: {
                created: "Команда успешно создана",
                updated: "Команда успешно обновлена",
                deleted: "Команда успешно удалена"
              },
              errors: {
                loadFailed: "Не удалось загрузить команды",
                saveFailed: "Не удалось сохранить команду",
                deleteFailed: "Не удалось удалить команду",
                nameRequired: "Название команды обязательно"
              }
            },
            aiWizard: {
              title: "Настройка AI",
              subtitle: "Настройте вашего AI-ассистента за несколько простых шагов",
              steps: {
                companyInfo: "О компании",
                aiAgent: "AI-агент",
                dataSources: "Источники данных",
                externalCrm: "Внешняя CRM",
                handoffRules: "Правила передачи",
                greeting: "Приветствие"
              },
              next: "Далее",
              back: "Назад",
              finishSave: "Завершить и сохранить",
              savedSuccess: "Настройки AI сохранены успешно!",
              saveFailed: "Не удалось сохранить настройки",
              companyStep: {
                companyName: "Название компании",
                companyNamePlaceholder: "напр. Моё турагентство",
                timezone: "Часовой пояс",
                responseLanguage: "Язык ответов",
                timezones: {
                  israel: "Израиль (Asia/Jerusalem)",
                  uk: "Великобритания (Europe/London)",
                  usEast: "США Восток (America/New_York)",
                  ukraine: "Украина (Europe/Kiev)"
                },
                languages: {
                  hebrew: "Иврит (עברית)",
                  english: "Английский",
                  russian: "Русский (Русский)",
                  arabic: "Арабский (العربية)"
                }
              },
              aiStep: {
                describeCompany: "Опишите вашу компанию и поведение AI",
                describePlaceholder: "напр. Мы турагентство, специализирующееся на семейных отпусках. AI должен помогать, предлагать направления и собирать предпочтения клиентов...",
                tone: "Тон общения",
                model: "Модель AI",
                tones: {
                  professional: "Профессиональный",
                  friendly: "Дружелюбный",
                  formal: "Формальный"
                },
                models: {
                  gpt4o: "GPT-4o (Лучшее качество)",
                  gpt4oMini: "GPT-4o Mini (Быстрее, дешевле)"
                }
              },
              dataStep: {
                description: "Подключите внешние API, чтобы AI мог получать реальные данные (товары, наличие, цены) во время разговоров. Это необязательно.",
                summaryTemplate: "Шаблон отображения сводки",
                summaryPlaceholder: "Как показывать собранные данные перед результатами. Используйте {{fields}} как плейсхолдер.",
                dataSourceNum: "Источник данных #{{num}}",
                name: "Название",
                namePlaceholder: "напр. Каталог товаров",
                apiUrl: "URL API",
                apiUrlPlaceholder: "https://api.mycompany.com/products",
                description2: "Описание (для AI)",
                descriptionPlaceholder: "Поиск товаров по критериям клиента",
                requiredFields: "Обязательные поля (через запятую)",
                requiredFieldsPlaceholder: "напр. категория, бюджет, размер, стиль",
                requiredFieldsHelper: "AI будет собирать эти поля по одному перед поиском",
                addDataSource: "Добавить источник данных"
              },
              crmStep: {
                description: "Подключите внешнюю CRM (Supabase) для автозаполнения данных клиентов из базы. Этот шаг можно пропустить.",
                enable: "Включить внешнюю CRM",
                supabaseUrl: "URL Supabase",
                supabaseKey: "API-ключ Supabase",
                testConnection: "Проверить подключение",
                tableName: "Таблица поиска",
                phoneField: "Столбец телефона",
                nameFields: "Столбцы имени",
                nameFieldsHelp: "Через запятую, напр. first_name, last_name",
                detectedFields: "Обнаруженные столбцы",
                skipNote: "Этот шаг необязательный. Если у вас нет внешней CRM, просто нажмите Далее."
              },
              handoffStep: {
                description: "Определите, когда AI должен передать разговор живому агенту.",
                customPlaceholder: "Опишите условие передачи...",
                addCustomRule: "Добавить правило",
                triggers: {
                  pricing: "Клиент спрашивает о ценах",
                  complaint: "Жалоба клиента",
                  humanRequest: "Клиент просит живого агента",
                  aiFailure: "AI не может ответить"
                }
              },
              greetingStep: {
                enableGreeting: "Включить автоприветствие",
                greetingMessage: "Сообщение приветствия",
                greetingPlaceholder: "напр. Привет! Добро пожаловать в наш магазин. Чем могу помочь?"
              }
            },
            tour: {
              buttons: {
                back: "Назад",
                close: "Закрыть",
                last: "Завершить",
                next: "Далее",
                skip: "Пропустить тур"
              },
              welcome: {
                title: "Добро пожаловать в Whapiz! 👋",
                content: "Давайте настроим ваш бизнес в 4 простых шага. Это займёт около 5 минут."
              },
              connections: {
                title: "Шаг 1 — Подключите номер WhatsApp",
                content: "Нажмите здесь, чтобы открыть страницу Соединений, где вы добавите свой номер WhatsApp Business API.",
                contentMobile: "Нажмите ☰ в левом верхнем углу, затем выберите 'Соединения'. Там подключается номер WhatsApp Business API."
              },
              metaButton: {
                title: "Нажмите 'Подключить WhatsApp Business API'",
                content: "Ваша команда предоставит 3 значения из Meta Business Manager: Phone Number ID, WABA ID и API Token. Вставьте их в шаге 2 мастера — и готово."
              },
              queues: {
                title: "Шаг 2 — Создайте первую очередь",
                content: "Очереди распределяют входящие чаты по отделу или теме (Продажи, Поддержка, Биллинг…). Нажмите здесь, затем '+Добавить' для создания первой.",
                contentMobile: "Нажмите ☰, затем 'Очереди'. Очереди распределяют входящие чаты по отделу (Продажи, Поддержка, Биллинг…). Нажмите '+Добавить' для создания первой."
              },
              botChoice: {
                title: "Шаг 3 — Выберите как бот отвечает",
                content: "У вас два варианта:\n\n📋 ПРОСТОЙ БОТ-МЕНЮ — Клиенты видят пронумерованное меню (1 - Продажи, 2 - Поддержка…). Легко настроить внутри каждой очереди → вкладка Опции.\n\n🤖 AI ПОМОЩНИК — GPT-4 отвечает естественным языком. Лучше всего для продаж и сложных вопросов. Следующий шаг открывает мастер настройки AI.\n\nМожно пропустить и решить позже."
              },
              aiSettings: {
                title: "AI Помощник (опционально)",
                content: "Заполните 6 коротких шагов, чтобы обучить AI о вашем бизнесе: данные компании, тон общения, источники знаний, CRM интеграция, когда передавать человеку, приветствие. AI использует GPT-4 и отвечает на языке клиента. Пропустите этот шаг, если предпочитаете простой бот-меню."
              },
              users: {
                title: "Шаг 4 — Пригласите команду",
                content: "Добавьте агентов, которые будут вести чаты с клиентами. У каждого агента свой логин и входящие.",
                contentMobile: "Нажмите ☰, затем 'Пользователи'. Добавьте агентов, которые будут вести чаты с клиентами — у каждого свой логин и входящие."
              },
              done: {
                title: "🎉 Всё готово!",
                content: "Ваши клиенты теперь могут писать вам, а команда может отвечать отсюда. Вы можете перезапустить этот тур в любое время из меню профиля."
              }
            },
            setupAssistant: {
              title: "AI-помощник настройки",
              subtitle: "Опишите ваш бизнес — я настрою бота",
              welcomeTitle: "Чем могу помочь с настройкой?",
              welcomeText: "Опишите ваш бизнес или выберите быстрый старт:",
              welcomeQuestions: "Привет! Я помогу настроить вашего WhatsApp бота. Начнём с нескольких вопросов:\n\n1. **Режим бота** — что предпочитаете?\n• **Чатбот** — меню с категориями, структурированные вопросы\n• **Прямой AI** — свободный разговор, без меню\n\n2. **Категории** — по каким темам обращаются ваши клиенты? (например: ремонт, оплата, запись...)\n\n3. **CRM** — есть ли у вас база клиентов, которую хотите подключить?\n\nОтветьте, и мы настроим бота шаг за шагом!",
              inputPlaceholder: "Опишите ваш бизнес...",
              error: "Извините, произошла ошибка. Попробуйте ещё раз.",
              applied: "Настройки применены! Проверьте поля и нажмите Сохранить.",
              configReady: "Конфигурация готова",
              applyConfig: "Применить конфигурацию",
              restart: "Начать сначала",
              suggestions: {
                building: "Управляющая компания",
                clinic: "Медицинская клиника",
                restaurant: "Ресторан / доставка еды",
                cleaning: "Клининговая компания",
                law: "Юридическая фирма"
              },
              config: {
                company: "Компания",
                mode: "Режим бота",
                language: "Язык",
                tone: "Тон",
                queues: "Очереди",
                greeting: "Приветствие",
                tasks: "Авто-задачи",
                crm: "Интеграция CRM"
              }
            },
            subscriptionsManager: {
              title: "Подписки компаний",
              subtitle: "Назначения тарифов и биллинг по всем клиентам",
              loadFailed: "Не удалось загрузить подписки",
              assignPlan: "Назначить план",
              assignSuccess: "План назначен успешно",
              assignFailed: "Не удалось назначить план",
              cancelConfirm: "Вы уверены, что хотите отменить эту подписку?",
              cancelSuccess: "Подписка отменена",
              cancelFailed: "Не удалось отменить подписку",
              recordPayment: "Записать платёж",
              paymentSuccess: "Платёж записан успешно",
              paymentFailed: "Не удалось записать платёж",
              refresh: "Обновить",
              cancel: "Отмена",
              noSubscriptions: "Подписок пока нет. Назначьте планы компаниям чтобы начать.",
              emptyDescription: "Подписок пока нет. Тенанты появятся здесь после активации плана.",
              table: {
                company: "Компания",
                plan: "План",
                status: "Статус",
                period: "Период оплаты",
                 autoRenew: "Автопродление",
                actions: "Действия"
              },
              form: {
                companyId: "ID компании",
                plan: "План",
                status: "Статус",
                periodMonths: "Период (месяцев)",
                amount: "Сумма",
                currency: "Валюта",
                description: "Описание",
                type: "Тип платежа",
                cancel: "Отмена",
                assign: "Назначить",
                record: "Записать платёж"
              }
            },
            billingPage: {
    paymentVerifying: "Проверяем платёж…",
    paymentVerifyingDesc: "Пожалуйста, подождите, пока мы подтверждаем транзакцию у платёжного провайдера.",
    paymentSuccessNoRef: "Отсутствует идентификатор платежа",
    paymentSuccessNoRefDesc: "Не найден идентификатор транзакции для проверки. Проверьте страницу оплаты.",
    paymentPendingTitle: "Платёж ещё обрабатывается",
    paymentPendingSubtitle: "Мы ещё не получили окончательное подтверждение. Это может занять минуту.",
    paymentCheckAgain: "Проверить снова",
    paymentNotFoundTitle: "Транзакция не найдена",
    paymentNotFoundSubtitle: "Не удалось найти эту транзакцию. Если с вас списали средства, обратитесь в поддержку.",
    paymentFailedTitle: "Платёж не прошёл",
    paymentFailedSubtitle: "Транзакция не завершена. Средства не списаны.",
    paymentSupportLine: "Нужна помощь? Напишите нам на {{email}}.",
    backToBilling: "Назад к оплате",
    backToDashboard: "На панель управления",
    viewInvoices: "Просмотр счетов",
    psPlan: "Тариф",
    psBillingPeriod: "Период оплаты",
    psReference: "Ссылка",
    psDate: "Дата",
    psCard: "Карта",
    psStarts: "Начало подписки",
    psNextCharge: "Следующее списание",
    psAutoRenew: "Автопродление",
    psAutoRenewOff: "Автопродление выключено",
    psAmount: "Списанная сумма",
    psInvoiceSent: "Счёт отправлен на {{email}}.",
    psInvoiceNote: "Ваш счёт доступен на странице оплаты.",
    interval_monthly: "Ежемесячно",
    interval_yearly: "Ежегодно",
    on: "Вкл",
    off: "Выкл",

              title: "Оплата и подписка",
              subtitle: "Управляйте подпиской, историей платежей и счетами",
              loadFailed: "Не удалось загрузить данные оплаты",
              tabs: {
                overview: "Обзор плана",
                payments: "История платежей",
                invoices: "Счета и квитанции"
              },
              currentPlan: "Текущий план",
              noPlan: "План не назначен",
              noPlanDesc: "Свяжитесь с администратором для назначения плана подписки.",
              noSubscription: "Нет активной подписки. Ваш план назначен, но оплата ещё не началась.",
              perMonth: "месяц",
              perYear: "год",
              trialBilling: "Пробный период",
              periodStart: "Начало периода",
              periodEnd: "Конец периода",
              trialEnds: "Пробный период до",
              features: {
                users: "Пользователей",
                connections: "Подключений WhatsApp",
                queues: "Очередей",
                ai: "AI-агент включён",
                crm: "Интеграция CRM"
              },
              paymentHistory: "История платежей",
              noPayments: "Платежей пока нет. История появится здесь.",
              invoiceHistory: "Счета и квитанции",
              noInvoices: "Счетов пока нет. Они появятся после оплаты.",
              downloadInvoice: "Скачать счёт",
              payNow: "Оплатить",
              renewSubscription: "Продлить подписку",
              renewDesc: "Продлите план, чтобы доступ не прерывался.",
              renewLoading: "Обработка…",
              renewFailed: "Не удалось продлить. Повторите попытку.",
              paymentSuccess: "Платёж успешно выполнен",
              paymentFailed: "Платёж не выполнен",
              pastDueBanner: "Ваша подписка просрочена. Оплатите для восстановления доступа.",
              trialBanner: "Пробный период активен. Перейдите на платный план в любое время.",
              noTerminal: "Платёжный терминал не настроен. Обратитесь в поддержку.",
              table: {
                date: "Дата",
                description: "Описание",
                amount: "Сумма",
                status: "Статус",
                method: "Способ оплаты",
                invoice: "Счёт #",
                actions: "Действия"
              }
            },
            requestPaymentDialog: {
              title: "Запросить оплату",
              confirmTitle: "Подтвердить запрос на оплату",
              recipient: "Получатель",
              unnamedContact: "этому контакту",
              amountLabel: "Сумма",
              currencyLabel: "Валюта",
              descriptionLabel: "Описание",
              descriptionHelp: "Показывается клиенту на странице Tranzila. Не более 80 символов.",
              confirmBody: "Отправить ссылку на оплату на сумму",
              confirmTo: "получателю",
              confirmHelp: "Ссылка будет доставлена сообщением WhatsApp в этом разговоре.",
              invalidAmount: "Введите сумму не менее 0.01.",
              invalidDescription: "Введите краткое описание (до 80 символов).",
              sentSuccess: "Ссылка на оплату отправлена клиенту.",
              sendFailed: "Не удалось отправить ссылку на оплату. Попробуйте ещё раз.",
              noTerminal: "Терминал Tranzila не настроен для вашей компании.",
              openSettings: "Открыть Настройки → Платежи",
              cancel: "Отмена",
              next: "Далее",
              sendNow: "Отправить ссылку на оплату"
            },
            aiWorkforcePage: {
              title: "AI Workforce",
              subtitle: "Правила, журналы действий и главный переключатель для пайплайна AI Agent.",
              notForTenant: {
                title: "Недоступно для этого арендатора",
                help: "Консоль AI Workforce используется только унаследованным пайплайном GoDeal. Обычные арендаторы настраивают AI на странице Настройки AI."
              },
              toggle: {
                title: "AI Workforce",
                description: "Главный переключатель — когда выключен, пайплайн AI Agent полностью обходится.",
                enabled: "AI Workforce включён",
                disabled: "AI Workforce выключен",
                failed: "Не удалось переключить AI Workforce"
              },
              tabs: {
                stats: "Статистика",
                rules: "Правила",
                logs: "Журнал действий"
              },
              stats: {
                totalAgents: "Агенты",
                activeAgents: "Активные",
                totalRules: "Правила",
                totalKnowledge: "База знаний",
                actionsToday: "Действий сегодня"
              },
              rules: {
                empty: "Правила ещё не определены.",
                newRule: "Новое правило",
                editRule: "Редактировать правило",
                edit: "Редактировать",
                delete: "Удалить правило",
                deleted: "Правило удалено",
                created: "Правило создано",
                updated: "Правило обновлено",
                deleteFailed: "Не удалось удалить правило",
                updateFailed: "Не удалось обновить правило",
                confirmDelete: "Удалить правило \"{{name}}\"? Это действие нельзя отменить.",
                col: {
                  name: "Название",
                  type: "Тип",
                  priority: "Приоритет",
                  active: "Активно",
                  actions: "Действия"
                },
                form: {
                  name: "Название",
                  type: "Тип",
                  typeHelp: "Свободный тег, например \"handoff\", \"intake_completed\", \"escalation\"",
                  priority: "Приоритет",
                  active: "Активно",
                  description: "Описание (опционально)",
                  conditions: "Условия (JSON)",
                  actions: "Действия (JSON)",
                  jsonHelp: "Схема зависит от движка. См. документацию AIAgentEngine.",
                  save: "Сохранить",
                  cancel: "Отмена",
                  saveFailed: "Не удалось сохранить правило",
                  invalidJson: "Некорректный JSON",
                  nameTypeRequired: "Название и тип обязательны"
                }
              },
              logs: {
                empty: "Записей в журнале действий ещё нет.",
                col: {
                  when: "Время",
                  action: "Действие",
                  agent: "Агент",
                  ticket: "Тикет",
                  status: "Статус",
                  latency: "Задержка",
                  error: "Ошибка"
                }
              },
              refresh: "Обновить",
              agents: {
                calendarConnected: "Календарь подключен ✓",
                secretaryName: "ИИ-секретарь — Назначение встреч",
                secretarySubtitle: "Подключено к календарю — встречи в естественной беседе",
                roles: {
                  appointment_scheduler: "Планировщик встреч"
                }
              }
            },
            aiSettingsPage: {
              title: "Настройки AI",
              subtitle: "Настройте поведение вашего AI-ассистента",
              goToAIWorkforce: "Перейти в AI Workforce",
              aiWorkforce: {
                title: "AI Workforce",
                description: "Включить или выключить всю AI обработку для этой компании",
                enabled: "AI Workforce включен",
                disabled: "AI Workforce выключен",
                toggleFailed: "Ошибка переключения AI Workforce"
              },
              saveChanges: "Сохранить",
              saving: "Сохранение...",
              settingsSaved: "Настройки сохранены!",
              failedToLoad: "Не удалось загрузить настройки AI",
              failedToSave: "Не удалось сохранить настройки",
              companyInfo: {
                title: "Информация о компании",
                companyName: "Название компании",
                companyNameHelp: "Отображаемое имя вашей компании. Появляется в сообщениях и приветствиях для клиентов.",
                timezone: "Часовой пояс",
                timezoneHelp: "Установите местный часовой пояс. Влияет на запланированные сообщения, отслеживание и рабочие часы.",
                language: "Язык",
                languageHelp: "Основной язык, на котором AI-бот будет общаться с клиентами.",
                timezones: {
                  israel: "Израиль",
                  uk: "Великобритания",
                  usEast: "США Восток",
                  ukraine: "Украина"
                },
                languages: {
                  hebrew: "Иврит",
                  english: "Английский",
                  russian: "Русский",
                  arabic: "Арабский"
                }
              },
              aiBehavior: {
                title: "Поведение AI",
                titleHelp: "Управляйте тем, как AI отвечает клиентам — его характер, база знаний и возможности.",
                systemPrompt: "Системный промпт",
                systemPromptHelp: "Пользовательские инструкции для AI. Опишите, что AI должен знать, как себя вести и чего никогда не делать. Самая важная настройка для управления поведением AI.",
                tone: "Тон",
                toneHelp: "Стиль общения AI. Профессиональный = деловой, Дружелюбный = тёплый и неформальный, Формальный = строгий и вежливый.",
                model: "Модель",
                modelHelp: "Модель AI. GPT-5 — самая мощная, но медленнее/дороже. GPT-4o Mini — быстрая и доступная для простых задач.",
                aiEnabled: "AI-агент включён",
                tones: {
                  professional: "Профессиональный",
                  friendly: "Дружелюбный",
                  formal: "Формальный"
                }
              },
              dataSources: {
                title: "Источники данных",
                description: "Внешние API, которые AI может использовать для получения данных в реальном времени.",
                sourceType: "Тип источника данных",
                sourceTypeHelp: "Как AI обращается к каталогу товаров/услуг. REST API = пользовательский эндпоинт. Supabase = прямой запрос к БД. Нет = без поиска по каталогу.",
                none: "Нет",
                restApi: "REST API",
                supabase: "Supabase",
                supabaseUrl: "URL Supabase",
                supabaseApiKey: "API ключ Supabase",
                summaryTemplate: "Шаблон отображения сводки",
                summaryHelperText: "Как показывать собранные данные. Используйте {{fields}} как плейсхолдер.",
                toolName: "Название",
                toolNameHelp: "Описательное имя источника данных. Пример: 'Поиск туров', 'Каталог товаров'.",
                toolApiUrl: "URL API",
                toolApiUrlHelp: "Полный URL эндпоинта API. AI будет вызывать этот URL для поиска товаров/услуг.",
                toolDescription: "Описание",
                toolDescriptionHelp: "Объясните простым языком, что делает этот API. AI использует это для решения, когда его вызывать.",
                requiredFields: "Обязательные поля (через запятую)",
                requiredFieldsPlaceholder: "напр. категория, бюджет (необязательно)",
                requiredFieldsHelp: "Поля, которые AI должен собрать у клиента перед вызовом API. Оставьте пустым для простого просмотра каталога.",
                requiredFieldsHelper: "Для простых запросов — оставьте пустым. Только для фильтрованного поиска.",
                addDataSource: "Добавить источник данных",
                maxProductCardsHelp: "Сколько карточек товаров/услуг показывать за один поиск. Меньше = быстрее, больше = больше выбора для клиента.",
                filterConfigHelp: "Расширенная JSON-конфигурация для маппинга данных клиента на параметры API. Редактируйте, только если знаете структуру API."
              },
              categoryStructure: {
                title: "Структура категорий",
                titleHelp: "Категории помогают AI организовать товары/услуги. Когда клиент что-то ищет, AI фильтрует по этим категориям. Можно автоопределить из данных или добавить вручную.",
                description: "AI использует эту структуру для понимания категорий данных и точной фильтрации. Сканируйте источник данных для автоопределения или настройте вручную.",
                autoDetect: "Автоопределение",
                scanning: "Сканирование...",
                autoDetected: "Автоопределено",
                manual: "Вручную",
                lastScan: "Последнее сканирование",
                categoryField: "Поле категории",
                categoryFieldHelper: "Поле в ваших данных, содержащее категорию",
                subcategoryField: "Поле подкатегории",
                subcategoryFieldHelper: "Необязательное вторичное поле группировки",
                items: "элементов",
                noCategories: "Категории ещё не определены. Нажмите \"Автоопределение\" для сканирования источника данных.",
                addManually: "Добавить категорию вручную",
                editName: "Изменить название",
                remove: "Удалить",
                detected: "Обнаружено {{count}} категорий",
                detectionFailed: "Определение не удалось",
                failedToScan: "Не удалось сканировать категории"
              },
              handoffRules: {
                title: "Правила передачи",
                titleHelp: "Правила, определяющие когда AI должен остановиться и передать разговор человеку. Включите встроенные правила или добавьте свои условия.",
                addCustomRule: "Добавить правило"
              },
              numberProfiles: {
                title: "Профили номеров WhatsApp",
                description: "Настройте поведение AI для каждого номера WhatsApp. Каждый номер может иметь свой режим бота, очереди AI и вопросы для сбора данных.",
                noNumbers: "Номера WhatsApp не найдены. Сначала добавьте подключение.",
                saveProfile: "Сохранить профиль",
                saved: "Профиль сохранён!",
                saveFailed: "Не удалось сохранить профиль",
                modeChatbot: "AI-чатбот (категории → вопросы → товары)",
                modeDirect: "Прямой AI (свободная беседа)",
                modeOff: "Выкл (только классический меню-бот)",
                systemPromptOverride: "Переопределение системного промпта",
                systemPromptOverrideHelp: "Переопределите общий промпт компании для этого номера. Оставьте пустым для использования промпта по умолчанию.",
                systemPromptPlaceholder: "Оставьте пустым для использования промпта компании по умолчанию",
                aiQueuesTitle: "Очереди AI-бота",
                aiQueuesHelp: "Определите категории обслуживания для выбора клиентом. Каждая очередь может иметь свои вопросы, автосоздание задач и шаблон резюме. Пример: 'Заявка на обслуживание', 'Оплата', 'Общие вопросы'.",
                queueName: "Название очереди",
                queueNameHelp: "Название, отображаемое клиенту в меню выбора. Используйте понятные простые названия.",
                queueDescription: "Описание",
                queueDescriptionHelp: "Краткое описание, чем занимается эта очередь. Помогает AI правильно направлять клиентов.",
                addQueue: "Добавить AI-очередь"
              },
              chatbotSettings: {
                title: "Настройки чат-бота",
                description: "Настройте, как чат-бот обрабатывает входящие разговоры перед передачей агенту.",
                botMode: "Режим бота",
                botModeHelp: "Выберите, как AI взаимодействует с клиентами. AI-чатбот = структурированный поток с меню и вопросами. Прямой AI = свободный AI-диалог. Выкл = без AI, только классическое меню.",
                botModeMenu: "Меню-бот (пошаговый)",
                botModeAI: "AI-бот (разговорный)",
                botModeHelper: "Меню-бот использует фиксированные меню. AI-бот ведёт естественный диалог для сбора информации.",
                questionsTitle: "Вопросы для сбора данных",
                questionsHelp: "Вопросы, которые бот задаёт перед передачей оператору. У каждого вопроса есть имя поля (для внутреннего использования) и текст, показываемый клиенту.",
                questionsDescription: "Определите информацию, которую AI должен собрать у клиента перед передачей агенту.",
                addQuestion: "Добавить вопрос",
                questionField: "Имя поля",
                questionFieldHelp: "Короткое внутреннее имя для данных. Используется в шаблонах и CRM. Пример: name, address, description, budget.",
                questionFieldHelper: "Внутреннее имя поля (например: направление, бюджет)",
                questionText: "Текст вопроса",
                questionTextHelp: "Точный вопрос, который бот задаст клиенту. Пишите на языке клиента. Пример: 'Как вас зовут?'",
                questionTextHelper: "Вопрос, который AI задаст клиенту",
                questionRequired: "Обязательно",
                questionRequiredHelp: "Если ВКЛ — бот будет спрашивать, пока клиент не ответит. Если ВЫКЛ — клиент может пропустить вопрос.",
                questionOptions: "Варианты (через запятую)",
                questionOptionsHelper: "Оставьте пустым для свободного текста. Например: Электроника, Украшения, Одежда. 1-3 = кнопки, 4+ = список.",
                noQuestions: "Вопросы для сбора данных не настроены. AI будет общаться свободно без сбора конкретных данных.",
                defaultQueue: "Очередь по умолчанию",
                defaultQueueHelper: "Очередь для назначения тикетов, когда AI не может определить нужную",
                noQueue: "Без очереди по умолчанию",
                autoCreateTask: "Автосоздание задачи после сбора данных",
                autoCreateTaskHelp: "Если включено, задача автоматически создаётся в системе после заполнения клиентом всех вопросов. Полезно для заявок на обслуживание.",
                summaryTemplate: "Шаблон резюме",
                summaryTemplateHelp: "Подтверждающее сообщение клиенту после заполнения формы. Используйте {{field}} для вставки собранных данных.",
                summaryTemplatePlaceholder: "напр. *Запрос принят!*\nИмя: {{name}}\nАдрес: {{address}}",
                summaryTemplateHelper: "Используйте {{field}} как подстановки. Оставьте пустым для шаблона компании."
              },
              greeting: {
                title: "Приветствие",
                titleHelp: "Приветственное сообщение отправляется автоматически при первом сообщении клиента или после длительного перерыва.",
                enableGreeting: "Включить автоприветствие",
                greetingMessage: "Сообщение приветствия",
                greetingMessageHelp: "Первое сообщение, которое видит клиент. Включите приветствие, название компании и чем бот может помочь."
              },
              sections: {
                general: "Общие настройки",
                generalDesc: "Данные компании, модель AI, язык и настройки приветствия",
                generalHelp: "Базовые настройки: название компании, язык, модель AI и приветствие, которое клиенты видят первым.",
                chatbotFlow: "Поток чат-бота",
                chatbotFlowDesc: "Режим WhatsApp-бота, очереди, вопросы и автоматизация задач",
                chatbotFlowHelp: "Настройте, как бот собирает информацию от клиентов. Настройте меню, вопросы и автосоздание задач для каждого номера WhatsApp.",
                productSearch: "Поиск продуктов",
                productSearchDesc: "Источники данных, фильтрация продуктов и структура категорий для каталога",
                productSearchHelp: "Подключите AI к каталогу товаров/услуг. AI будет искать и показывать клиентам релевантные товары во время разговоров.",
                externalCrm: "Внешняя CRM",
                externalCrmDesc: "Подключение к внешней базе данных (Supabase) для поиска клиентов, синхронизации задач и платежей",
                advanced: "Расширенные",
                advancedDesc: "Правила передачи и другие расширенные настройки",
                advancedHelp: "Определите, когда AI должен остановиться и передать разговор оператору.",
                active: "Активно"
              },
              crm: {
                enableIntegration: "Включить интеграцию с внешней CRM",
                connectionTitle: "Подключение",
                connectionHelp: "Введите URL вашего проекта Supabase и API-ключ. Их можно найти в панели Supabase: Settings → API.",
                supabaseUrl: "URL Supabase",
                supabaseKey: "API-ключ Supabase",
                testConnection: "Проверить подключение",
                edgeFunctionPath: "Путь Edge Function (опционально)",
                edgeFunctionPathHelp: "Если задан, запросы идут через Edge Function вместо прямого REST. Пример: /functions/v1/crm-api",
                customerLookupTitle: "Поиск клиента",
                customerLookupHelp: "Когда клиент отправляет сообщение в WhatsApp, бот ищет его в базе данных по номеру телефона и автоматически заполняет данные (имя, адрес и т.д.). Бот не будет задавать вопросы, ответы на которые уже известны.",
                customerLookupDesc: "Автоматическое заполнение данных клиента из базы данных при получении сообщения. Уменьшает количество вопросов.",
                tableName: "Имя таблицы",
                tableNameHelp: "Название таблицы в базе данных с записями клиентов. Пример: customers, contacts, tenants",
                phoneField: "Столбец телефона",
                phoneFieldHelp: "Название столбца в таблице с номерами телефонов. Пример: phone, mobile, tenant_phone",
                nameFields: "Столбцы имени",
                nameFieldsHelp: "Имена столбцов через запятую, например first_name, last_name",
                extraField1: "Доп. поле 1 (опционально)",
                extraField1Help: "Дополнительное поле для заполнения, напр. адрес, отдел, компания",
                extraField2: "Доп. поле 2 (опционально)",
                extraField2Help: "Ещё одно поле, напр. квартира, юнит, ID аккаунта",
                cachedFields: "Поля для запоминания (через запятую)",
                cachedFieldsHelp: "Дополнительные поля из ответа поиска, которые нужно сохранить для последующих вызовов (например building_id, apartment_id, customer_id). Обязательно, если шаблон задачи ссылается на {notes.<field>}.",
                detectedFields: "Обнаруженные столбцы",
                taskSyncTitle: "Синхронизация задач",
                taskSyncHelp: "Автоматическая синхронизация задач, созданных ботом, во внешнюю базу данных. Когда клиент заполняет форму, запись задачи создаётся в CRM.",
                taskTable: "Таблица задач",
                syncTasksToCrm: "Синхронизировать задачи в CRM",
                defaultTaskType: "Тип задачи по умолчанию",
                defaultTaskTypeHelp: "Используется, когда ни одно ключевое слово не совпало. Укажите значение, которое CRM всегда принимает (например repair, general).",
                requireFields: "Обязательные поля (через запятую)",
                requireFieldsHelp: "Пропускать вызов внешней CRM, если хотя бы одно из этих полей отсутствует в notes. Защита от ошибок 400, когда поиск клиента не дал результата.",
                taskTypeMap: "Карта типов задач (JSON)",
                taskTypeMapHelp: 'Сопоставьте каждому task_type, который принимает CRM, список ключевых слов. Побеждает первое совпадение (без учёта регистра, по подстроке в имени очереди). Пример: {"emergency": ["leak","fire"], "repair": ["broken","fix"]}',
                payloadTemplate: "Шаблон тела create_task (JSON)",
                payloadTemplateHelp: "Структура тела запроса, которую ожидает ваша CRM. Используйте плейсхолдеры {{title}}, {{taskType}}, {{priority}}, {{description}}, {{phone}}, {notes.<field>}. Оставьте пустым для тела по умолчанию.",
                advanced: {
                  title: "Расширенно — сопоставление типов задач и шаблон",
                  description: "Заполняйте только если CRM требует строгий enum task_type или нестандартное тело запроса. По умолчанию работает для большинства Supabase-настроек.",
                  jsonParseError: "Невалидный JSON",
                  jsonMustBeObject: "JSON должен быть объектом"
                },
                paymentCheckTitle: "Проверка платежей",
                paymentCheckHelp: "Позволяет боту проверять статус оплаты из базы данных. Когда клиент спрашивает о платежах, бот может найти баланс и историю оплат.",
                paymentTable: "Таблица платежей",
                paymentStatusField: "Столбец статуса"
              },
              companyKnowledge: {
                title: "База знаний компании",
                description: "Профиль бизнеса, правила, FAQ — добавляются в системный промпт AI для каждого чата с клиентом.",
                profile: "Профиль бизнеса",
                overview: "Описание бизнеса",
                overviewPlaceholder: "Чем занимается ваш бизнес, кого обслуживаете? (2-3 предложения)",
                serviceAreas: "Регионы обслуживания (через запятую)",
                escalationPhone: "Телефон для эскалации",
                escalationEmail: "Email для эскалации",
                communication: "Стиль общения",
                addressForm: "Форма обращения",
                toneStyle: "Тон и стиль",
                stopTopics: "Запретные темы (через запятую)",
                disclaimers: "Обязательные оговорки (через запятую)",
                rules: "Правила бизнеса",
                addRule: "Добавить правило",
                neverDo: "Жёсткие запреты",
                addNeverDo: "Добавить запрет",
                neverDoPlaceholder: "Никогда не обсуждай цены конкурентов",
                faq: "FAQ",
                addFaq: "Добавить FAQ",
                faqQuestion: "Вопрос",
                faqAnswer: "Ответ"
              }
            },
            sitePages: {
              sidebarHeading: "Страницы",
              selectPage: "Выберите страницу для редактирования",
              loadError: "Не удалось загрузить страницы",
              saveSuccess: "Страница сохранена",
              saveError: "Ошибка сохранения",
              statusError: "Ошибка обновления статуса",
              published: "Страница опубликована",
              unpublished: "Страница переведена в черновик",
              statusPublished: "Опубликовано",
              statusDraft: "Черновик",
              setDraft: "В черновик",
              publish: "Опубликовать страницу",
              save: "Сохранить",
              saving: "Сохраняю…",
              fieldTitle: "Заголовок страницы",
              fieldMetaTitle: "Meta Title",
              fieldMetaDesc: "Meta Description",
              fieldBody: "Содержимое страницы (HTML)",
              metaTitleHint: "Максимум 70 символов. Используется Google как заголовок страницы в результатах поиска.",
              metaDescHint: "Максимум 160 символов. Показывается под заголовком в результатах поиска Google.",
              bodyHint: "Полное HTML-содержимое страницы. Отображается как есть на whapiz.com.",
              tooLong: "Слишком длинно — Google обрежет",
              slugs: {
                termsOfService: "Условия использования",
                privacyPolicy: "Политика конфиденциальности",
                aboutUs: "О нас",
                cookiePolicy: "Политика cookie"
              }
            }
          }
        }
      };

export { messages };
